<template>
  <div id="detailPage" class="detail-page">
    <skeleton v-if="!isSkeletonLoading" :nums="4" fheight="4rem" iheight="2rem"></skeleton>
    <div class="detail-page" :style="{'height': $util.isInternalChannel()? 'calc(100% - 1rem)': ''}" v-else>
      <div>
        <div class="goods-detail-container">
          <div class="header">
            <div class="scroll-0" v-show="!navShowFlag && !commentHeader">
              <div @click="fnBack" class="left" v-if="!+$route.query.browerFirstIn">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.backIcon"></use>
                </svg>
              </div>
              <div v-else></div>
              <div  v-if="!disableGoOut" class="right share-icon" :class="{ show: showShareFlag }" @click="openShareModal">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.shareIcon"></use>
                </svg>
              </div>
            </div>
            <div class="scroll" v-show="navShowFlag && !commentHeader">
              <div @click="fnBack" class="left" v-if="!+$route.query.browerFirstIn">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.backIcon"></use>
                </svg>
              </div>
              <div class="tab">
                <div :class="{ active: activeAnchor === 'goodsContainer' }" @touchstart="fnScrollTo('goodsContainer', $event)" class="tab-item">
                  <span>商品</span>
                </div>
                <div :class="{ active: activeAnchor === 'commentContainer' }" @touchstart="fnScrollTo('commentContainer', $event)" class="tab-item">
                  <span>评价</span>
                </div>
                <div v-if="showProdDetail" :class="{ active: activeAnchor === 'detailContainer' }" @touchstart="fnScrollTo('detailContainer', $event)" class="tab-item">
                  <span>详情</span>
                </div>
                <div v-if='!$util.isInternalChannel() && !$util.isShopKeeper()' :class="{ active: activeAnchor === 'guessLikeContainer' }" @touchstart="fnScrollTo('guessLikeContainer',$event)" class="tab-item">
                  <span>推荐</span>
                </div>
              </div>
              <div v-if="!disableGoOut" class="right" :class="{ show: showShareFlag }" @click.stop="openShareModal">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.shareIcon"></use>
                </svg>
              </div>
            </div>
            <div class="scroll" v-show="commentHeader">
              <div @click="commentBack" class="left">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.backIcon"></use>
                </svg>
              </div>
              <div class="comment-header-title">商品评价</div>
              <div v-if="!disableGoOut" class="right" :class="{ show: showShareFlag }" @click.stop="openShareModal">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.shareIcon"></use>
                </svg>
              </div>
            </div>
          </div>
          <liveTag v-if="hotLiveInfo.length && hotLiveInfo[0].liveState == 1" class="detail-livetag" @click.native="doOpenLive(hotLiveInfo[0])"/>
          <div id="innerView" class="inner-view" ref="scrollBox" @scroll="handleScroll">
            <floatButton v-if="show_live === '2'" @click="gotoLive"></floatButton>
            <div class="goods-container" id="goods-container" ref="goodsContainer">
              <swiper ref="swiper" v-if="showSwiper" :images="swiperImgs" :products="products"  @swiperChange="swiperChange" @sceenChange="sceenChange" :gioObject="gioObject" :firstImageInfo="firstImageInfo"/>
              <goods-info
                :needAppointment="needAppointment"
                :activityInfo="activityInfo"
                :attrValueNames="attrValueNames"
                :baseInfo="baseInfo"
                :rightsList="rightsList"
                :couponList="couponList"
                :couponGiftList="couponGiftList"
                :descriptionList="descriptionList"
                :finished="finishedCoupon && finishedCouponGift"
                :hbFqInfo="hbFqInfo"
                :xjFqInfo="xjFqInfo"
                :ioucInfo="ioucInfo"
                :location="location"
                :oldForNewFlag="oldForNewFlag"
                :priceInfo="priceInfo"
                :productId="productId"
                :productNumber="productNumber"
                :products="products"
                :sgAttribute="sgAttribute"
                :sgStockInfo="sgStockInfo"
                :sgStoreAttribute="originAttrs"
                :isCanSelectTitle="isCanSelectTitle"
                :sgStoreAttributeItem="sgStoreAttributeItem"
                :storeInfo="storeInfo"
                :voucherList="voucherList"
                :voucherGiftList="voucherGiftList"
                :checkCouponIsAllGet="checkCouponIsAllGet"
                :getGoodsUseCouponInfo=" couponList.length ? getGoodsUseCouponInfo : getGoodsCanUseCouponInfo"
                :btnType="btnType"
                :hasSubProduct="hasSubProduct"
                :checkedAttr="checkedAttr"
                :isExclusive="isExclusive"
                :canSetPrice="baseInfo.canChangePrice"
                :attrLength="attrLen"
                :parentBookable="parentBookable"
                :spuInfo="spuInfo"
                :swiperImgs="swiperImgs"
                :notSaleStatus="notSaleStatus"
                :visitStore="visitStore"
                :noticeContent="noticeContent"
                :isCollected="isCollected"
                :guiderList="guiderDisplayList"
                :plusInfo="plusInfo"
                :discountActivityInfo="discountActivityInfo"
                :discountActivityText="discountActivityText"
                @gioHZ20017="gioHZ20017"
                @manageSetPrice="manageSetPrice"
                :trkOrigin="trkOrigin"
                @fnCollect="fnCollect"
                @fnAddCart="fnAddCart"
                @fnChangeProductNumber="fnChangeProductNumber"
                @fnGoBuy="fnGoBuy"
                @fnSelectAttribute="fnSelectAttribute"
                @getDes="getDes"
                @goBaitiao="goBaitiao"
                @handleLocation="handleLocation"
                @receiveCoupon="receiveCoupon"
                @attrNameChange="attrNameChange"
                @countdownFinish="countdownFinish"
                @resetBtnType="resetBtnType"
                @fnArrivalNotice="fnArrivalNotice"
                @toggleShowInfo="toggleShowInfo"
                @bookableBuy="bookableBuy"
                @attrSelectChanged="attrSelectChanged"
                @titleSelectOption="titleSelectOption"
                @fnReserve="fnReserve"
                @fnSelectSpu="fnSelectSpu"
                @fnHb="fnHb"
                @goShopDetail="goShopDetail"
                ref="goodsInfo"
              />
            </div>
            <div v-if="showComment" class="comment-container" id="comment-container" ref="commentContainer">
              <lazy-comment-info
                :commentList="commentList"
                :commentTotal="commentTotal"
                :positiveRate="positiveRate"
                :productId="productId"
                :show="commentHeader"
                :storeId="staticStoreId"
                @toggleCommentHeader="toggleCommentHeader"
                @fnShowCommentContent="fnShowCommentContent"
              />
              <goods-recommend :relationList="relationList" v-if="relationList.length" />
              <!-- 问答区域 -->
              <answer-area :info="answerAreaInfo" @gioHZ20017="gioHZ20017"></answer-area>
            </div>
            <!-- 商品推荐 -->
            <div>
              <recommendation :productId="Number(productId)"></recommendation>
            </div>
            <div v-if="showComment && !disableGoOut" style="padding: 0 0.24rem;">
              <lazy-shop-info :stockInfo='sgStockInfo' :storeInfo="storeInfo" v-if="showShopInfo" @gioHZ20017="gioHZ20017"/>
            </div>
            <div class="detail-container" id="detail-container" ref="detailContainer">
              <lazy-goods-detail
                v-if="showProdDetail"
                :mp4FileId2="mp4FileId2"
                :products="products"
                :productAttrs="productAttrs"
                :productDetails="productDetails"
                :richText="richText"
                :sgBottomPic="sgBottomPic"
                :sgTopPic="sgTopPic"
                :afterSales="afterSales"
              />
            </div>
            <div ref="guessLikeContainer" v-if="!$util.isInternalChannel() && !$util.isShopKeeper() && (!o2oStoreId || (o2oStoreId && storeInfo?.mdCode)) && dynamicLoaded">
              <guess-you-like page="detail" key="guessyoulike1" scrollEle="innerView" :productTypeId="productTypeId" v-if="o2oStoreId" :storeId="o2oStoreId" :mdCode="storeInfo?.mdCode" :productId="productId" @gioBD20114="gioBD20114" @gioHZ20017="gioHZ20017" @gioBD20271="gioBD20271" @handleGoodClick="handleGoodClick"/>
              <guess-you-like page="detail" key="guessyoulike2" scrollEle="innerView" :productTypeId="productTypeId" v-else :storeId="o2oStoreId" :mdCode="storeInfo?.mdCode" :productId="productId" @gioBD20114="gioBD20114" @gioHZ20017="gioHZ20017" @gioBD20271="gioBD20271" @handleGoodClick="handleGoodClick"/>
            </div>
            <!-- <navigation /> -->
          <div class="none-sale-container" v-if="notSaleStatus">
            <div class="none-sale-left" style="font-size: 12px" v-if="sgStockInfo.skuDisplayReason">
              <span class="tip-text">{{sgStockInfo.skuDisplayReason}}</span>
            </div>
            <div class="none-sale-left" style="font-size: 12px" v-else-if="storeInfo && storeInfo.mdBizState !== 1">
              <span class="tip-text">该店铺已失效，暂无法购买</span>
            </div>
            <div class="none-sale-left" style="font-size: 12px" v-else-if="!products.onSale">
              <span class="tip-text">该商品未在平台上架，暂无法购买</span>
            </div>
            <template v-else>
              <div class="none-sale-left">
                <svg class="icon-svg tips-icon" aria-hidden="true">
                  <use xlink:href="#icon-universal_shibai"></use>
                </svg>
                <span class="tip-text">{{sgStockInfo.skuDisplayState === 3?'此商品不支持在当前地区销售':'当前地区超出该门店配送范围'}}</span>
              </div>
              <div class="none-sale-right" @click="changeAddress">
                <span class="location-text">切换地址</span>
                <svg class="icon-svg location-right-arrow" aria-hidden="true">
                  <use xlink:href="#icon-universal_more"></use>
                </svg>
              </div>
            </template>
          </div>
          <div class="pre-sale-tip-container" :style="{'bottom':notSaleStatus?'2.08rem':''}" v-if="preSaleTipShow && !preSaleTipClose">
            <div class="pre-sale-tip">
              <svg class="icon-svg tip-icon" aria-hidden="true">
                <use xlink:href="#icon-ic_lingdang"></use>
              </svg>
              <span>如需购买，请返回场景页面购买</span>
              <div class="tip-close-btn" @click="preSaleTipClose = true">
                <svg class="icon-svg" aria-hidden="true">
                  <use :xlink:href="$globalIcon.closeIconNew"></use>
                </svg>
              </div>
            </div>
          </div>
          </div>
          <div v-show="!disableGoOut" class="bottom-wrap" :class="{ 'no-store': !showShop || $util.isInternalChannel() }">
            <ul>
              <li @click="fnGoToStore" v-checklogin="PlatformTypes.UPLUS | PlatformTypes.SC_H5" v-show="showShop && !$util.isInternalChannel()">
                <div class="li-inner">
                  <div class="img-box">
                    <svg class="icon-svg" aria-hidden="true">
                      <use xlink:href="#icon-icon_store_l"></use>
                    </svg>
                  </div>
                  <div class="text">店铺</div>
                </div>
              </li>
              <li @click="fnOpenCustomerService">
                <div class="li-inner">
                  <div class="img-box">
                    <svg class="icon-svg" aria-hidden="true">
                      <use xlink:href="#icon-kefu"></use>
                    </svg>
                  </div>
                  <div class="text">客服</div>
                </div>
              </li>

              <li @click="fnOpenCart" v-if="!hideCartBtn">
                <div class="li-inner">
                  <div class="img-box">
                    <div class="box">
                      <svg class="icon-svg" aria-hidden="true">
                        <use xlink:href="#icon-gouwuche"></use>
                      </svg>
                      <div class="badge" v-if="cartNumber">{{ cartNumber > 99 ? ' 99+' : cartNumber }}</div>
                    </div>
                  </div>
                  <div class="text">购物车</div>
                </div>
              </li>
              <li v-else></li>
              <li v-if='!dynamicLoaded'>
                <!-- 在没有加载完成数据前，仅用于展示，代替loading -->
                <div class="btn-box btn-disabled" >
                  <div class="btn add-cart">加入购物车</div>
                  <div class="btn buy">
                    <p>{{ '立即购买' }}</p>
                  </div>
                </div>
              </li>
              <li v-else-if="baseInfo.showToShop">
                <div class="btn-box">
                  <div class="btn buy" @click="showYyDialog">预约到店</div>
                </div>
              </li>
              <li v-else-if="needAppointment">
                <div class="btn-box">
                  <div class="btn buy" @click="showAppointment">一键预约</div>
                </div>
              </li>
              <li v-else :class="{ disabled: notSaleStatus }">
                <!-- 店铺拼团 -->
                <template v-if="activityInfo && activityInfo.activityType === 75">
                  <div class="btn-box">
                    <div @click="openAttr(9)" class="group-origin-btn">
                      <div class="origin-price">￥{{ (priceInfo.minOriginPrice || priceInfo.originPrice || 0) | formatPrice }}</div>
                      <span class="text">原价购买</span>
                    </div>
                    <div @click="openAttr(10)" class="group-origin-btn" style="background-color: #FF5252">
                      <div class="origin-price">￥{{ (priceInfo.minPrice || priceInfo.actualPrice || 0) | formatPrice }}</div>
                      <span class="text">拼团购买</span>
                    </div>
                  </div>
                </template>
                <div class="btn-box" v-else-if="notSaleStatus">
                  <div class="btn add-cart">加入购物车</div>
                  <div class="btn buy" :class="{ orange: voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons }">
                    <p class="btn-text">{{ activityInfo && activityInfo.activityType === 70 ? '立即抢购' : baseInfo.showCoupons ? (checkCouponIsAllGet ? '立即购买' : '领券购买') : '立即购买' }}</p>
                    <h6 v-if="voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons">到手价{{ getGoodsUseCouponInfo.price.toFixed(2) }}</h6>
                  </div>
                </div>
                <div class="btn-box spec" v-else-if="hasSubProduct">
                  <!-- 只针对多规格处理底部按钮逻辑 -->
                  <!-- 有库存情况只显示 立即购买与加入购物车 -->
                  <!-- 库存数取自新接口 此处记得更改 -->
                  <template v-if="sgStockInfo && sgStockInfo.stockNum > 0">
                    <div v-if="baseInfo.supportCart && !hideCartBtn" @click="openAttr(0)" class="btn add-cart">加入购物车</div>
                    <!-- 暗券多规格商品 -->
                    <div  class="btn-group-flex" v-if="couponList.length === 0 && !priceInfo.plusPrice && getGoodsCanUseCouponInfo.isCouponReceived && getGoodsCanUseCouponInfo.bestCoupon && !isExclusive">
                      <div @click="openAttr(1)" class="orange">
                        <p class="btn-text">立即购买</p>
                        <h6 >到手价{{ getGoodsCanUseCouponInfo.yhprice.toFixed(2) }}</h6>
                      </div>
                    </div>
                    <div v-else @click="openAttr(1)" class="btn buy" :class="{ orange: voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons }">
                      <p class="btn-text">
                        {{ activityInfo && activityInfo.activityType === 70 ? '立即抢购' : baseInfo.showCoupons ? (checkCouponIsAllGet ? '立即购买' : '领券购买') : '立即购买' }}
                      </p>
                      <h6 v-if="voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons">到手价{{ getGoodsUseCouponInfo.price.toFixed(2) }}</h6>
                    </div>
                  </template>
                  <template v-else>
                    <!-- 无库存 展示 马上预定 + 加入购物车 或 到货通知 -->
                    <template v-if="sgStockInfo.bookable">
                      <div v-if="baseInfo.supportCart && !hideCartBtn" @click="openAttr(0)" class="btn add-cart">加入购物车</div>
                      <div class="btn btn-text" :class="[$util.isInternalChannel()?'buy':'book']" @click="openAttr($util.isInternalChannel()?1:3)">{{$util.isInternalChannel()?'立即购买':'马上预定'}}</div>
                    </template>
                    <template v-else>
                      <div class="btn arrival-notice btn-text" @click="fnArrivalNotice">
                        {{ !$util.isInternalChannel() ? '到货通知': '已下架'}}
                      </div>
                    </template>
                  </template>
                </div>
                <div class="btn-box" v-else>
                  <div v-if="baseInfo.supportCart && !hideCartBtn && !isExclusive" @click="openAttr(0)" class="btn add-cart">加入购物车</div>
                  <!--  -->
                  <!-- 拼连接 activityType活动类型说明：
                101 定金尾款预热，价格显示actualPrice，显示倒计时，距开始时间
                100 定金尾款抢购中 限时预约价 actualPrice，最终价格 finalPrice，原价 originPrice，显示倒计时，到活动结束时间，如果deposit是1展示全款购买按钮，全款购买价格用originPrice,无库存也要现实支付定金
                81 预约抢购预约中，价格展示actualPrice，不展示立即购买，展示立即预约按钮，显示倒计时，到活动结束时间
                80 预约抢购中，价格展示actualPrice，显示倒计时，到活动结束时间
                70 限时抢购，价格展示actualPrice，显示倒计时，到活动结束时间 活动为空时，取actualPrice
                75 店铺拼团活动期 价格展示actualPrice，显示倒计时，到活动结束时间 活动为空时，取actualPrice
                76 店铺拼团预热-->
                  <!-- activityType为81不校验库存 -->
                  <template v-if="activityInfo && activityInfo.activityType === 81">
                    <div class="btn reservation" @click="fnReserve">立即预约</div>
                  </template>
                  <!-- 需要校验库存 -->
                  <template v-else>
                    <!-- 无库存 -->
                    <template v-if="sgStockInfo && !sgStockInfo.hasStock">
                      <!-- 定金尾款 -->
                      <template v-if="activityInfo && activityInfo.activityType === 100 && sgStockInfo.bookable">
                        <div @click="openAttr(4)" class="btn bdl bdt" v-if="activityInfo.deposit === 1">
                          <div class="btn-inner">
                            <!-- <div>￥{{ priceInfo.originPrice ? priceInfo.originPrice : 0 | formatPrice }}</div> -->
                            <div>原价购买</div>
                          </div>
                        </div>
                        <div @click="openAttr(5)" class="btn bg" v-if="activityInfo.deposit === 1">
                          <div class="btn-inner">
                            <!-- <div>￥{{ priceInfo.actualPrice ? priceInfo.actualPrice : 0 | formatPrice }}</div> -->
                            <div>支付订金</div>
                          </div>
                        </div>
                        <div class="btn bg" @click="openAttr(5)" v-if="activityInfo.deposit !== 1">
                          ￥{{ priceInfo.actualPrice ? priceInfo.actualPrice : 0 | formatPrice }} 订金支付
                        </div>
                      </template>
                      <!-- 马上预定 -->
                      <template v-else-if="sgStockInfo.bookable">
                        <!-- <div class="btn book" @click="fnGoBuy('1', '5')">马上预定</div> -->
                        <div class="btn btn-text" :class="[$util.isInternalChannel()?'buy':'book']" @click="openAttr($util.isInternalChannel()?1:3)">{{$util.isInternalChannel()?'立即预定':'马上预定'}}</div>
                      </template>
                      <!-- 到货通知 -->
                      <template v-else-if="!sgStockInfo.bookable">
                        <template v-if="!notSaleStatus">
                          <div class="btn arrival-notice btn-text" @click="fnArrivalNotice">
                            {{ !$util.isInternalChannel() ? '到货通知': '已售罄'}}
                          </div>
                        </template>
                        <template v-else>
                          <!-- 定金尾款 -->
                          <template v-if="activityInfo && activityInfo.activityType === 100">
                            <div @click="openAttr(4)" class="btn bdl bdt" v-if="activityInfo.deposit === 1">
                              <div class="btn-inner">
                                <!-- <div>￥{{ priceInfo.originPrice ? priceInfo.originPrice : 0 | formatPrice }}</div> -->
                                原价购买
                              </div>
                            </div>
                            <div @click="openAttr(5)" class="btn bg" v-if="activityInfo.deposit === 1">
                              <div class="btn-inner">
                                <!-- <div>￥{{ priceInfo.actualPrice ? priceInfo.actualPrice : 0 | formatPrice }}</div> -->
                                支付订金
                              </div>
                            </div>
                            <div class="btn bg" @click="openAttr(5)" v-if="activityInfo.deposit !== 1">
                              ￥{{ priceInfo.actualPrice ? priceInfo.actualPrice : 0 | formatPrice }} 订金支付
                            </div>
                          </template>
                          <template v-else>
                            <div @click="openAttr(1)" class="btn buy" :class="{ orange: voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons }">
                              <p class="btn-text">
                                {{
                                  activityInfo && activityInfo.activityType === 70
                                    ? '立即抢购'
                                    : baseInfo.showCoupons
                                    ? checkCouponIsAllGet
                                      ? '立即购买'
                                      : '领券购买'
                                    : '立即购买'
                                }}
                              </p>
                              <h6 v-if="voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons">到手价{{ getGoodsUseCouponInfo.price.toFixed(2) }}</h6>
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                    <!-- 有库存 -->
                    <template v-else>
                      <!-- 定金尾款 -->
                      <template v-if="activityInfo && activityInfo.activityType === 100">
                        <div @click="openAttr(4)" class="btn bdl bdt" v-if="activityInfo.deposit === 1">
                          <div class="btn-inner">
                            <!-- <div>￥{{ priceInfo.originPrice ? priceInfo.originPrice : 0 | formatPrice }}</div> -->
                            原价购买
                          </div>
                        </div>
                        <div @click="openAttr(5)" class="btn bg" v-if="activityInfo.deposit === 1">
                          <div class="btn-inner">
                            <!-- <div>￥{{ priceInfo.actualPrice ? priceInfo.actualPrice : 0 | formatPrice }}</div> -->
                            支付订金
                          </div>
                        </div>
                        <div class="btn bg" @click="openAttr(5)" v-if="activityInfo.deposit !== 1">
                          ￥{{ priceInfo.actualPrice ? priceInfo.actualPrice : 0 | formatPrice }} 订金支付
                        </div>
                      </template>
                      <!-- 暗券 立即购买 (非活动 非会员价 非专属价 且有暗券) -->
                      <div  class="btn-group-flex" v-else-if="couponList.length === 0 && !priceInfo.plusPrice && getGoodsCanUseCouponInfo.isCouponReceived && getGoodsCanUseCouponInfo.bestCoupon && !isExclusive">
                        <div @click="openAttr(1)" class="orange">
                          <p class="btn-text">立即购买</p>
                          <h6 >到手价{{ getGoodsCanUseCouponInfo.yhprice.toFixed(2) }}</h6>
                        </div>
                      </div>
                      <div v-else class="btn-group-flex" :class="{'btn-group-double': isExclusive}">
                        <div class="add-cart" v-if="isExclusive" @click="openAttr(0)">加入购物车</div>
                        <div @click="openAttr(1)" :class="{ orange: voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons }">
                          <p class="btn-text">
                            {{
                              activityInfo && activityInfo.activityType === 70 ? '立即抢购' : baseInfo.showCoupons ? (checkCouponIsAllGet ? '立即购买' : '领券购买') : '立即购买'
                            }}
                          </p>
                          <h6 v-if="voucherList.length && getGoodsUseCouponInfo.type == 'sheng' && baseInfo.showCoupons">到手价{{ getGoodsUseCouponInfo.price.toFixed(2) }}</h6>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </li>
            </ul>
          </div>
          <!-- <div class="none-sale-container" v-if="notSaleStatus">
            <div class="none-sale-left" v-if="sgStockInfo.skuDisplayReason"><span class="tip-text">{{sgStockInfo.skuDisplayReason}}</span></div>
            <div class="none-sale-left" v-else><div class="tips-icon"></div><span class="tip-text">{{sgStockInfo.skuDisplayState === 3?'此商品不支持在当前地区销售':'当前地区超出该门店配送范围'}}</span></div>
            <div class="none-sale-right" @click="changeAddress" v-if="!sgStockInfo.skuDisplayReason"><span class="location-text">切换地址</span><div class="location-right-arrow"></div></div>
          </div> -->
          <!-- 预约信息确认框 -->
          <reservation-confirm-box @fnChangeReservationShowFlag="fnChangeReservationShowFlag" @reserve="reserve" @sendSmsCaptcha="sendSmsCaptcha" v-show="reservationShowFlag" />
          <exclusiveFinish v-if="showExclusiveTip" />
          <!-- 到货通知 -->
          <van-dialog @confirm="fnNotice" :close-on-click-overlay="true" :show-cancel-button="false" :show-confirm-button="false" title="到货通知" v-model="dialogShow">
            <div class="product-name">
              <span class="title">商品名称</span>
              <p>{{ products.productFullName }}</p>
            </div>
            <van-field placeholder="请输入手机号" type="tel" v-model="mobile" maxlength="11" />
            <div class="btn-container">
              <div class="confirm-btn" @click="fnNotice">确定</div>
            </div>
            <div class="dialog-close" @click="dialogShow = false"></div>
          </van-dialog>
          <div class="mask-close" v-show="isAllSceenSwiper">
            <svg class="icon-svg close" aria-hidden="true" id="maskClose">
              <use :xlink:href="$globalIcon.closeIconNew"></use>
            </svg>
            <span>{{ curSwiper }}/{{ swiperImgs.length }}</span>
          </div>
          <div id="maskVideo" class="mask-video" @touchmove.stop.prevent></div>
          <div id="good-component-container"></div>
        </div>
      </div>
      <custom-share
        v-if="loadShareModal"
        :wechatTimeLine="1"
        :show.sync="showShareModal"
        :canSetPrice="baseInfo.canChangePrice"
        :isExclusive="isExclusive"
        :copyCustomLink="true"
        @copyLink="copyLink"
        @customShare="defaultShareFn"
        @pictureShare="openPictureShare"
        @manageSetPrice="manageSetPrice"
      ></custom-share>
      <picture-share v-if="loadPictureShare" :show.sync="showPictureShare" :rightsList="rightsList"></picture-share>
      <!-- 返回顶部 -->
      <top-feedBack
        :isShow="showTotop && !commentHeader"
        :classList="{ 'top-margin-no-sale': notSaleStatus, 'has-bottom-bar': !notSaleStatus }"
        @hiddenFeedBack="hiddenFeedBack"
        @toTop="toGotop"
      ></top-feedBack>

      <!-- 设置专属价弹窗 -->
      <ManagePriceDialog ref="managePriceDialog" v-if="showSetPrice" :products="products" @close="closeManageDialog" @submit="doSetPrice"/>
      <!-- 非生态标品 预约弹窗 -->
      <appointment-popup
        v-if="needAppointment"
        :showAppointmentPopup="showAppointmentPopup"
        @close="showAppointmentPopup = false"
        :products="products"
        :storeInfo="storeInfo"
      />
    </div>
    <!-- 柜电套餐预约到店 -->
    <div class="detail-fixedbtn-dj" v-if="guidianyybtn" @click="showYyDialog"></div>
    <van-popup v-model="yyddDialogModal" position="bottom" style="border-top-left-radius: .24rem; border-top-right-radius: .24rem">
      <YyddDialog  @close="closeYyDialog"/>
    </van-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters, mapMutations, mapState } from 'vuex'

import URL from '@/http/url'
import UplusApi from '@uplus/uplus-api'
// import { tmpIdsMap } from '@/config/constMap'
// import config from '@/config'
// import idsMap from '@/config/tmpIdsMap'
import config from '@/config'
import { PlatformTypes } from '@/config/constMaps'
import { needJumpLogin } from '@/directives/login'
import exclusiveFinish from '../exclusive-finish/index'
import personalApi from '@/http/service/index'
import { getOrderPaySourceIdByEnv } from '@/views/order/cashier/common/orderSource'
// import navigation from './components2b/navigation'
import {
  productQrCode,
  getProductBasicInfo,
  getVirtualSpuInfo,
  dynamic,
  getProductAvailableCoupons,
  getGiftCouponListByStoreAndSku,
  receiveCoupon,
  getDes,
  relation,
  promos,
  specifications,
  evaluation,
  getCommentsByCondition,
  checkStockForNum,
  checkOnly,
  insertNotice,
  getActivityInfoByScene,
  // getIoucCost,
  getProductTradeInInfo,
  checkMemberReserve,
  sendSmsCaptcha,
  getMaxAnswerProductQuestion,
  reserve,
  queryExclusivePrice,
  getSkusLiveInfo,
  querySingleOnlineRightsList,
  postServiceCenter,
  entrance,
} from '@/http/service/goods'
import { getCustomer } from '@/http/service/personal.js'
import {
  getGoodsGuide,
  getGuideProfile,
} from '@/http/service/chat'
// import personalApi from '@/http/service/index'
import utils from '@/utils/utils'
import { MixinShare2b, MixinGio, MixinCollect } from './mixins'
// import md5 from '@/utils/md5'
import { getUcLoginUrl } from '@/http/service/common.js'
import userKeyTarget from '@/utils/userTarget'
import skeleton from '@/components/skeleton/index.vue'
import ManagePriceDialog from './components2b/manage-price-dialog.vue'
import appointmentPopup from './components2b/appointment-popup.vue'
import YyddDialog from './components2b/yydd-dialog.vue'
const liveTag = () => import('@/components/liveTag')
const guessYouLike = () => import('@/components/guessYouLick/new')
const topFeedBack = () => import('@/components/top-feedBack/index')
const answerArea = () => import('./components2b/answer-area.vue')
const recommendation = () => import('./components2b/recommendation.vue')
const customShare = () => import('@/components/custom-share/custom-share2b')
const pictureShare = () => import('@/components/picture-share/picture-share')
import swiper from './components2b/swiper'
const lazyShopInfo = () => import(/* webpackChunkName: "lazy-shop-info" , webpackPrefetch: true */ './components2b/shop-info')
const goodsRecommend = () => import('./components2b/goods-recommend')
const reservationConfirmBox = () => import('./components2b/reservation-confirm-box')
const floatButton = () => import('@/components/floatButton')
const lazyGoodsDetail = () => import(/* webpackChunkName: "lazy-goods-detail" , webpackPrefetch: true */ './components2b/goods-detail')
const lazyCommentInfo = () => import(/* webpackChunkName: "lazy-comment-info" , webpackPrefetch: true */ './components2b/comment-info')
import goodsInfo  from './components2b/goods-info'
import { ORDERFORMENUM } from '@/config/enums'
import { SCENE_SYNCG } from '@/viewsToB/procurement/constants';
const { mapActions } = createNamespacedHelpers('cart')
const instance = new UplusApi()
instance.initDeviceReady()
const sharePlatform = {
  'WechatSession': '微信',
  'WechatTimeLine': '朋友圈',
  'QQ': 'QQ',
  'QQzone': 'QQ空间',
  'Sina': '微博',
  'CopyLink': '复制链接',
  'PictorialShare': '画报分享',
}
const entranceMap = {
  'qrCode':'扫码',
  'shareTask':'分享',
  'share':'分享',
}

let cancelToken = () => {}

export default {
  mixins: [MixinShare2b, MixinGio, MixinCollect],
  provide() {
    return {
      getCurScrollTop: () => {
        return this.scrollTop
      },
    }
  },
  inject: ['reload'],
  components: {
    skeleton,
    goodsInfo,
    lazyCommentInfo,
    swiper,
    answerArea,
    recommendation,
    lazyShopInfo,
    goodsRecommend,
    lazyGoodsDetail,
    floatButton,
    YyddDialog,
    reservationConfirmBox,
    exclusiveFinish, // 专属价结束弹窗
    liveTag,
    ManagePriceDialog,
    appointmentPopup, // 非标品生态商品 预约弹窗
    customShare,
    pictureShare,
    guessYouLike,
    topFeedBack
  },
  data() {
    return {
      dynamicInfo: {},
      afterSales: '',
      enterTime: 0, // 进入页面时间
      showSwiper: true,
      islogining: false, // 是否正在登录中(未拿到token禁止操作)
      scrollTop: 0, // 滚动距离
      exclusiveId: '', // 专属id
      visitStoreId: '', // 专属店铺id
      exclusiveFinished: false,
      exclusiveUsed: false,
      swiperSkeleton: true,
      navShowFlag: false,
      showShareFlag: false, // 控制分享按钮展示
      // isPageShow: false, // 是否打开页面
      showSetPrice: false, // 设置专属价弹窗
      activeAnchor: 'goodsContainer',
      productId: '', // 商品ID
      storeId: '', // 分享人id
      curSwiper: 1, // 当前swiper index
      swiperImgs: [],
      // isActiveBanner: false, // 是否是动态活动，需要添加到轮播第一张
      isAllSceenSwiper: false, // 是否是全屏预览
      products: {},
      checkedAttr: '',
      attrValueNames: '',
      attrLen: 0, // 规格长度
      skku: '',
      sgAttribute: null,
      hasSubProduct: false, // 是否含有子商品，多规格逻辑需要针对处理
      sgStoreAttribute: null,
      originAttrs: [],
      sgStoreAttributeItem: null,
      productNumber: 1,
      activityInfo: null,
      baseInfo: {},
      priceInfo: {},
      firstImageInfo: null,
      sgStockInfo: {},
      storeInfo: null,
      couponList: [], // 优惠券信息
      voucherList: [], // 优惠券列表
      couponGiftList: [], // 礼品券信息
      voucherGiftList: [], // 礼品券列表
      couponGiftData: [], // 礼品券数据
      finishedCoupon: false,
      finishedCouponGift: false,
      descriptionList: [], // 服务说明
      commentTotal: 0,
      positiveRate: 0,
      commentList: [], // 评论列表
      relationList: [], // 关联商品列表
      mp4FileId2: '', // 图文详情视频信息
      sgTopPic: '',
      richText: '',
      productDetails: '',
      sgBottomPic: '',
      productAttrs: [],
      dialogShow: false, // 控制dialog
      mobile: '', // 到货通知需填的手机号
      hbFqInfo: null, // 花呗分期信息
      xjFqInfo: null, // 分期信息
      ioucInfo: { feeInfo: '查看更多' }, // 白条信息
      shareGoodsInfo: {}, // 分享的商品信息
      reservationShowFlag: false, // 控制预约确认弹窗
      show_live: '', // 控制直播悬浮按钮显示  1：唤醒直播弹窗 2：展示btn
      hotLiveInfo: [], // 直播信息
      shopInfo: null, // 立即购买埋点 产品信息数据
      gioObject: {}, // 埋点对象
      o2oStoreId: '', // storeId埋点
      answerAreaInfo: {}, // 问答区域数据
      commentHeader: false,
      holdSelected: '', // 暂存已选商品
      cancelScroll: false, // 开关滚动区域
      staticStoreId: '',
      isCanSelectTitle: true, // 是否允许长安选择标题
      showComment: false, // 加载评论和详情
      isSkeletonLoading: false, // 是否加载完成动态接口
      btnType: -1, // 点击的按钮类型 0:加购 1：立即购买 2: 到货通知 3：马上预定 4:全款支付 5:定金支付 6:立即购买+购物车 7:定金支付+全款支付  8:立即预约-1:无操作 9: 拼团中的原价购买 10: 拼团购买 11: 已选来的拼团购买
      attrInitStatus: false, // 规格初始化状态，只初始化一次
      parentBookable: false, // 多规格商品主商品 是否可预定状态
      attrHasSelect: false, // 标记规格是否是选中状态 单规格默认选中，多规格默认不选中
      spuInfo: null, // spu信息
      openFrom: 1, // 从何处打开的选择弹窗 1：已选 2：真实按钮
      lastSelectRealBtn: 1, // 上次选中的真实按钮
      noticeContent: undefined,
      originSource: null, // 冰箱屏二维码携带参数
      showTotop: false, // 返回顶部控制
      canShowTotopInterval: null,
      preScrollBoxScrollTop: 0,
      chooseGroupId: 0, // 参团拼团Id
      // hideStockNum: false, // 隐藏库存数
      oldForNewFlag: false, // 以旧换新开关
      rightsList: [], // 权益列表,
      guiderList: [],
      preSaleTipShow: false, // 预售底部提示控制
      preSaleTipClose: false, // 提示关闭标识，关闭后 keep-alive返回不在展示
      productUrl: '',
      cardId: '', // 客服中心卡片id
      trk_origin: '', // 上级页面来源
      hideCartBtn: 0, // 是否隐藏购物车相关按钮
      drainageCode: '', // 场景引流码
      trkOrigin: '',
      productTypeId: 0, // 商品类型
      cnxhClickItem: {}, // 点击的猜你喜欢商品信息
      hbIndex: -1, // 花呗分期索引
      payNum: 0, // 花呗分期数
      visitStore: '', // 店铺id
      mdCode: '', // 门店code
      uid: '', // 推荐人用户中心id
      plusInfo: { 
        showPlusEntrance: false, // 是否显示plus会员开通入口
        additionalSave: '', // 额外省金额
      },
      showAppointmentPopup: false, // 生态非标品预约弹窗
      discountActivityInfo: {}, // 凑单折扣信息
      discountActivityText: '', // 凑单折扣文案
      PlatformTypes,
      couponCanUseList: [], // 可用优惠券列表(暗券)
      // newgoodpicurl: '', //测试调试
      yyddDialogModal: false, //预约到店信息弹窗
      SCENE_SYNCG
    }
  },
  computed: {
    ...mapGetters(['sourceTypeAndCode']),
    ...mapGetters('mymanage', ['getCurrentRole']),
    ...mapGetters(['accessToken', 'ucId', 'getUserIdentifyInfo', 'sourceTypeAndCode']),
    ...mapState('cart', ['cartNumber']),
    ...mapState('chat', ['isTimLogin']),
    // 动态接口响应结束，判断某些元素是否开始加载
    dynamicLoaded() {
      return this.dynamicInfo && this.dynamicInfo?.baseInfo
    },
    trulyPrice() {
      // 获取商品真实价格 （如果是plus会员 则返回plus价格，如果不是会员且有活动价则返回finalPrice，否则返回actualPrice）
      // let finalPrice = this.$util.isUplus() && this.getUserIdentifyInfo?.plusInfo?.plus && this.$util.isShowMemberPrice() && !!this.priceInfo.plusPrice ? this.priceInfo.plusPrice : this.priceInfo.actualPrice
      if (this.$util.isUplus() && this.getUserIdentifyInfo?.plusInfo?.plus && this.$util.isShowMemberPrice() && !!this.priceInfo.plusPrice) {
        return  this.priceInfo.plusPrice
      }  
      return this.priceInfo ? (this.priceInfo.priceType === 100 ? this.priceInfo.finalPrice : this.priceInfo.actualPrice) : null
    },
    needAppointment () {
      // 是否需要展示 非标品一键预约 按钮
      const { query } = this.$route
      return this.products?.standardAttribute === 2 && Number(query.directSaleType) === 3 && query.sceneCode && query.fkcode
    },
    //是否显示柜电套餐按钮
    guidianyybtn(){
      // return true
      return this.shopInfo?.data?.toShop && this.sgStockInfo?.hasStock && (!this.$util.isHaierApp() || this.$util.isUplus())
    },

    guiderDisplayList() {
      return !this.exclusiveUsed && this.$route.query.exclusiveId ? [] : this.guiderList
    },
    notSaleStatus() { // 是否不可购买状态 false可购买 true 不可购买
      return (this.sgStockInfo && (this.sgStockInfo.skuDisplayState === 3 || this.sgStockInfo.skuDisplayState === 4 || this.sgStockInfo.skuDisplayReason)) || (this.storeInfo && this.storeInfo?.mdBizState !== 1) || !this.products?.onSale
    },
    showShopInfo() {
      return (this.sgStockInfo?.stockType === 'WA' || this.sgStockInfo?.stockType === 'ZJ' || !this.storeInfo || this?.storeInfo?.storeType === 3) && !this.$util.isInternalChannel()
    },
    location() {
      return this.$store.getters['getlocationInfo']
    },
    mId() {
      return this.$store.getters['mId']
    },
    getShareId() {
      const shareUserId = sessionStorage.getItem('shareUserId')
      return (shareUserId && shareUserId != undefined && shareUserId != 'undefined') ? shareUserId : ''
    },
    isExclusive() {
      return !this.exclusiveUsed && this.priceInfo.priceType === 200
    },
    showShop() {
      return this.storeInfo && this.storeInfo.mdCode && (!this.storeInfo.storePublicDomainName || (this.storeInfo.storePublicDomainName && (this.storeInfo.storeType === 0 || this.storeInfo.storeType === 1) && !((this.sgStockInfo.stockType === 'O2O' || this.sgStockInfo.stockType === 'OCO') && this.notSaleStatus)))
    },
    showExclusiveTip() {
      return this.priceInfo.priceType === 200 && (this.exclusiveUsed || this.exclusiveFinished)
    },
    checkCouponIsAllGet() {
      let filterArrr = this.voucherList.filter(item => item.marking === 'sheng')
      // console.log(filterArrr, 'filterArrr')
      return filterArrr.every(item => item.displayType === '2')
    },
    // 获取当前商品可领 可用券
    getGoodsUseCouponInfo() {
      console.log(this.voucherList, 'voucherList')
      let type = this.voucherList.some(item => item.marking === 'sheng') ? 'sheng' : this.voucherList.some(item => item.marking === 'cou') ? 'cou' : ''
      console.log(type, 'type')
      let yhprice = 0
      let buyNum = 1
      // 智家app环境下，是plus会员，且显示plus价格，且存在plus价格的时候，取plus价；否则取actualPrice
      let finalPrice = this.trulyPrice// this.$util.isUplus() && this.getUserIdentifyInfo?.plusInfo?.plus && this.$util.isShowMemberPrice() && !!this.priceInfo.plusPrice ? this.priceInfo.plusPrice : this.priceInfo.actualPrice
      this.voucherList.forEach(item => {
        if (item.marking === 'sheng' || item.marking === 'cou') {
          yhprice += item.couponAmount
          buyNum = item.buyNum
        }
      })
      return {
        type,
        buyNum,
        price: finalPrice * buyNum - yhprice > 0 ? finalPrice * buyNum - yhprice : 0,
        yhprice,
        voucherLen: this.voucherList.length,
        isCouponReceived: false, //是否是已领可用  否
      }
    },
    // 获取当前商品是否有暗券互斥活动
    getAnyCouponMutexActivity() {
      return this.dynamicInfo?.activityInfo?.activityType !== 0 || !!this.dynamicInfo?.discountActivityInfo
    },
    // 获取最优已领暗券 并计算使用优惠券后的价格
    getGoodsCanUseCouponInfo() {
      // 多规格商品 未选规格时, 互斥活动， 不展示暗券
      if (this.sgAttribute && this.sgStoreAttribute && Number(this.attrLen) === 0 || this.getAnyCouponMutexActivity) {
        return {
          type:'',
          buyNum: 0,
          price: 0,
          yhprice: 0,
          voucherLen: 0,
          isCouponReceived: true, //是否是已领可用  是
        }
      }

      let type = this.couponCanUseList.some(item => item.marking === 'sheng') ? 'sheng' : this.couponCanUseList.some(item => item.marking === 'cou') ? 'cou' : ''
      let buyNum = 1
      let finalPrice = this.trulyPrice
      let yhprice = finalPrice
      let bestCoupon
      let couponCanUseList = this.couponCanUseList.filter(item => item.limitAmount <= finalPrice)
      if (couponCanUseList.length >= 2) {
        couponCanUseList.reduce((a, b) => { return a.couponValue > b.couponValue ? a : b })
      }
      couponCanUseList.forEach(item => {
        // 满足可用门槛
        if (item.limitAmount <= finalPrice) {
          // 比较其他优惠券的优惠金额
          const _yhprice = item.couponType === 'DISCOUNT_COUPON' ? finalPrice * Number(item.couponValue) / 100 : (finalPrice - Number(item.couponValue))
          if (yhprice > _yhprice) {
            yhprice = _yhprice
            bestCoupon = item
          }
        }
      })
      // 优惠价格不可为负数
      if (yhprice < 0) {
        yhprice = 0
      }
      return {
        type,
        buyNum,
        price: finalPrice,
        yhprice,
        voucherLen: this.couponCanUseList.length,
        bestCoupon,
        isCouponReceived: true, //是否是已领可用  是
      }
    },
    showProdDetail() {
      // return !this.baseInfo?.platTags?.includes(6) && this.dynamicLoaded
      // 去掉无素材商品校验逻辑，全部展示
      return this.dynamicLoaded
    },
    // 因为采购专区进入其他页面后，就跳出了采购台阶计划，所有能跳转的组件都禁用
    disableGoOut(){
      return this.$route.query.scene === SCENE_SYNCG
    }
  },
  watch: {
    "storeInfo.storeCode" : {
      handler: function (val) {
        if (val) {
          this.getCustomerInfo()
        }
      },
      immediate: true
    },
    sgStockInfo: {
      deep: true,
      handler(newVal, oldVal) {
        // 如果当前库存数量为0 且不可以预定，则设置为0
        if (newVal.stockNum === 0 && !newVal.bookable && !newVal.hasStock) {
          this.productNumber = 0
        }
      }
    }
  },
  created() {
    this.drainageCode = this.$route.query.drainageCode || ''
    let hideCartBtn = Number(this.$route.query.hideCartBtn)
    this.hideCartBtn = hideCartBtn && !isNaN(hideCartBtn) ? 1 : 0
    // this.init();
    // 获取地址传入的 originSource（冰箱屏二维码扫描）
    this.originSource = this.$route.query.originSource || ''
    this.uid = this.$route.query.uid || ''
  },
  beforeMount() {
    this.debouncedBuyAction = utils.debounceImmediate(this.doBuyAction)
  },
  mounted() {
    this.skku = this.$route.query.skku || ''
    // 参数中含有直营参数且为2，3，4时则隐藏库存，【测试部朱辰确认的逻辑】
    // const { query: _q } = this.$route
    // if (['2', '3', '4'].includes(_q.directSaleType)) {
    //   this.hideStockNum = true
    // }
    // window.addEventListener('pageshow', () => {
    //   this.isPageShow = true
    //   this.fetchRecordShareRelation()
    // });
  },
  // 非法商品id访问 进行拦截跳转
  beforeRouteEnter(to, from, next) {
    if (utils.isSgRn()) {
      const productId = to.query.productId
      const visitStore = to.query.visitStore
      const mdCode = to.query.mdCode || ''
      window.postMessage(
        JSON.stringify({
          type: 'goProduct',
          data: {
            id: productId,
            storeId: visitStore || '',
            mdCode
          },
        })
      )
      // 解决在RN的客服中无法通过超链接打开M站单品页
      // next(from && from.fullPath && from.fullPath === '/')
      return false
    } else {
      next(vm => {
        if (from.name === 'channel' || from.name === 'newchannel') {
          vm.$store.commit('setDownloadAppType', 0)
        }
        vm.trk_origin = from?.meta?.trk_origin
      })
      // if (idsMap[productId]) {
      //   window.location.replace(`${config.HOST}/sgmobile/itSoluteDetail?id=${idsMap[productId]}`)
      // } else {
      //   next()
      // }
    }
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('shareMessage')
    // enterTime && this.gioMB13407()
    if (this.enterTime) {
      this.gioMB13407()
      this.gioBD20114()
    }
    next()
  },
  beforeDestroy() {
    if (this.$util.isHaierApp()) {
    // 智家APP onresume生命周期检查支付状态,移除监听
      instance.removeResumeEventListener('onresume_key').catch(e=>console.log(e))
    }
  },
  deactivated() {
    // 如果有视频实例 进行销毁 防止回退时无法实例化
    if (this.$refs?.swiper) {
      this.$refs?.swiper?.player?.dispose?.()
      this.$refs.swiper.player = null
      this.$refs.swiper.smallVideoShow = false
    }
    // this.showSwiper = false // 解决二次激活该页面时，视频组件无法创建的问题
  },
  activated() {
    if (this.$util.isUplusSharedH5()) {
      sessionStorage.removeItem('open_source')
      if (needJumpLogin(PlatformTypes.SC_H5)) {
        return
      }
    }
    this.enterTime = Date.now()
    this.init()
    this.productUrl = window.location.href
    this.addListener()
    this.trkOrigin = this.$route.query?.trk_origin || this.trk_origin || 'null'
    // if (this.swiperImgs.length > 0) {
    //   this.$nextTick(() => {
    //     this.showSwiper = true // 解决二次激活该页面时，视频组件无法创建的问题
    //   })
    // }
  },
  
  methods: {
    ...mapMutations('orderRight', ['setOrderRightInfos', 'setOrderProInfo', 'setSelectedRights', 'setGiveupStatus', 'setExclusiveStatus']),
    ...mapMutations('goodsDetail', ['setgoodsDetailInfo']),
    async fetchRenewedInfo(){
      const { success, data } = await getProductTradeInInfo({
        sku: this.products?.sku,
        mdCode: this.storeInfo?.mdCode
      })
      if(success && data){
        this.baseInfo = {
          ...this.baseInfo,
          renewedInfo: data
        }
      }
      // this.baseInfo.renewedInfo = {
      //   tradeIn: true,
      //   tradeInAMT: 200,
      //   tradeInLink: 'http://baidu.com'
      // }
    },

    showAppointment() {
      // 一键预约
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.$store.dispatch('doLogin').finally(() => {
          this.islogining = false
        })
        return
      }
      this.showAppointmentPopup = true
    },

    handleGoodClick(item){
      this.cnxhClickItem = item
    },
    // 三翼鸟足迹浏览上报
    toSYNFootPrint() {
      let url = config.DHOST + URL.getSYNfootprint
      const params = {
        sku: this.products.sku,
        storeId: this.o2oStoreId,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        districtId: this.location.districtId,
        streetId: this.location.townshipId,
      }
      if (this?.storeInfo?.mdCode) params.mdCode = this.storeInfo.mdCode
      this.$http.post(url, params)
    },
    // 复购分佣接口调用
    fetchRecordShareRelation() {
      if (this.$store.state.shareId && !sessionStorage.getItem('isRecordShareRelation')) {
        sessionStorage.setItem('isRecordShareRelation', true)
        this.$http.get(URL.recordShareRelation, {
          params: {
            sharerMemberId: this.$store.state.shareId || '',
            storeProductId: this.$route.query.productId || '',
            storeId: this.o2oStoreId || '',
          },
        })
      }
    },
    // ...mapMutations('answerArea', ['setAnswerAreaInfo']),
    async init() {
      console.log('+++++++++++++++++init+++++++++++++++++++++++')
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      // });
      // Promise.resolve(()=>{
      //   this.$toast.clear()
      // })
      const { query: _q } = this.$route
      if (_q.exclusiveId) {
        this.queryExclusivePrice(_q.exclusiveId) // 查询专属价使用信息
      }
      if (utils.isHaierApp()) {
        this.doShowUplusLive()
      }
      this.productNumber = 1
      this.productId = _q.productId
      this.visitStore = _q.visitStore
      this.mdCode = _q.mdCode
      try {
        if ((!this.visitStore && !this.mdCode) && this.$util.isShopKeeper()) {
          let storeConfig = await this.$util.getAppStorageStringValue('eshop_main_current_store_config')
          storeConfig = this.$util.strJSONParse(storeConfig, {})
          console.log('storeConfig', storeConfig)
          if (storeConfig?.storeId) {
            this.visitStore = storeConfig?.storeId
          }
          if (storeConfig?.mdCode) {
            this.mdCode = storeConfig?.mdCode
          }
        }
      } catch (err) {}
      this.storeId = _q.storeId || '' // 分享人id
      this.show_live = _q.show_live || ''
      // this.skku = _q.skku || ''
      this.$set(this.gioObject, 'fkCode', _q.fkcode)
      this.$set(this.gioObject, 'fcCode', _q.sceneCode)
      this.$set(this.gioObject, 'trkOrigin', _q?.trk_origin || this.trk_origin)

      if (this.$util.isIhaierApp()) {
        // ihaier 显示分享按钮
        this.showShareFlag = true
      } else if (this.$util.isHaierApp()) {
        // U+ 显示分享按钮
        this.showShareFlag = true
        // U+ 登陆处理
        // const authFlag = await this.$store.dispatch('handleUpAuth')
      
      }
      
      this.getProductBasicInfo().then(res1 => {
        this.isSkeletonLoading = true
        if (this.products.videoUrl) {
          let videoUrl = this.$util.strJSONParse(this.products.videoUrl, { video: this.products.videoUrl })
          // 判断是否是移动端兼容 m3u8格式
          if (this.$util.isM3U8Supported() && videoUrl.m3u8Video) {
            this.swiperImgs = [
              {
                img: videoUrl.img,
                video: videoUrl.m3u8Video,
              },
              ...this.shopInfo.data.swiperImgs,
            ]
          } else {
            this.swiperImgs = [
              {
                img: videoUrl.img,
                video: videoUrl.video,
              },
              ...this.shopInfo.data.swiperImgs,
            ]
          }
         
        } else {
          this.swiperImgs = this.shopInfo.data.swiperImgs
        }
        // 避免与静态接口和动态接口争夺资源，使用promise 微任务队列
        Promise.resolve().then( () => {
          // 由于要显示plus会员到手价，这里更新用户身份，防止开通plus会员后，到手价不变
          if (this.$store.state.isLogin) {
            try {
              this.$store.dispatch('queryIdentity')
            }catch (err) {
              console.log(err)
            }
          }
          this.getVirtualSpuInfo(this.productId).then(s => {}).catch(e => { console.log(e) });
          // 更新购物车数量
          if (this.$store.getters.getLoginStatus) {
            this.getCartNumber()
          }
          this.swiperChange(0, !this.products.videoUrl)
          this.getCardId()
          // 获取非首屏信息
          this.relation()
          this.promos()
          this.specifications()
          this.evaluation()
          this.getCommentsByCondition()
          // 获取问答区域数据
          this.getMaxAnswerProductQuestion({
            sku: this.products.sku,
            productId: this.productId,
            productFullName: this.products.productFullName,
            defaultImageUrl: this.swiperImgs.length && this.swiperImgs[0],
          }) 
          // IH20034 内购进入埋点
          this.$util.trackWithVariable({
            platformConf: {
              [PlatformTypes.INTERNAL_CHANNEL]: {
                id: 'IH20034',
                param: ['product_id', 'product_name']
              },
            },
          },{
            product_id: this.gioObject.productId ? this.gioObject.productId + '' : 'null',
            product_name: this.gioObject.productName || 'null',
          }).then(res => {
            console.log('report res', res)
          })
          if (this.$util.isHaierApp()) {
            // 获取分享信息
            this.productQrCode()
          }
        });
      }).catch(e => { console.log(e) });
      this.dynamic().then(res2 => {
        
        // 三翼鸟足迹
        if (this.$util.isSyBird() || this.$route.query.fromSource === 'syn') {
          this.toSYNFootPrint()
        }
        if (!this.sgStockInfo?.bookable && !this.sgStockInfo?.hasStock && this.sgStockInfo?.sceneBookable) {
          // 场景预售提示开启
          this.preSaleTipShow = true
        }
        this.$set(this.gioObject, 'mdCode', this.storeInfo?.mdCode)
        this.$util.gioTrackWithVariable('ProView', {
          member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
          user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
          deliverStreet: this.$store.state.locationInfo.township || 'null',
          deliverDistrict: this.$store.state.locationInfo.district || 'null',
          deliverCity: this.$store.state.locationInfo.city || 'null',
          deliverProvince: this.$store.state.locationInfo.province || 'null',
          storeId: this.gioObject.storeId ? this.gioObject.storeId + '' : 'null',
          stockStatus: this.gioObject.stockStatus ? this.gioObject.stockStatus + '' : 'null',
          productCode: this.gioObject.productEncode ? this.gioObject.productEncode + '' : 'null',
          productName_var: this.gioObject.productName || 'null',
          productId_var: this.gioObject.productId ? this.gioObject.productId + '' : 'null',
        })
        let eventId = 'WBSC20003'
        if (this.$util.isSyBird() || this.$util.isSyBirdH5()) {
          eventId = 'BD20333'
        }
        this.$util.gioTrackWithVariable(eventId, {
          md_code: this.storeInfo?.mdCode ? this.storeInfo.mdCode + '' : 'null',
          md_name: this.storeInfo?.o2OStoreName ? this.storeInfo.o2OStoreName + '' : 'null',
          store_id: this.gioObject.storeId ? this.gioObject.storeId + '' : 'null',
          store_name: this.storeInfo?.o2OStoreName ? this.storeInfo.o2OStoreName + '' : 'null',
          product_id: this.gioObject.productId ? this.gioObject.productId + '' : 'null',
          product_name: this.gioObject.productName || 'null',
          province: this.location.province ? this.location.province + '' : 'null',
          city: this.location.city ? this.location.city + '' : 'null',
          county: this.location.district ? this.location.district + '' : 'null',
          street: this.location.township ? this.location.township + '' : 'null',
          stock_status: this.gioObject.stockStatus ? this.gioObject.stockStatus + '' : 'null',
          sku_code: this.gioObject.productEncode ? this.gioObject.productEncode + '' : 'null',
          fk_code: this.$route.query.fkcode ? this.$route.query.fkcode + '' : 'null',
          fc_code: this.$route.query.sceneCode ? this.$route.query.sceneCode + '' : 'null',
          scene_name: 'null',
          origin: this.$route.query?.trk_origin || this.trk_origin || 'null',
          third_platform: this.$route.query?.sharePlatform ? sharePlatform[this.$route.query?.sharePlatform] : 'null',
          share_id: this.$route.query.shareId,
          share_user_id: this.uid,
          entrance: this.$route.query?.linkType ? entranceMap[this.$route.query?.linkType] : 'null',
          source_type: this.$route.query?.source_type || 'null',
          source_code: this.$route.query?.source_code || 'null',
        })
        if (this.$util.isShopKeeper()) {
          this.$util.gioTrackWithVariable('YG20099', {
            product_id: this.gioObject?.productId,
            product_name: this.gioObject?.productName,
            store_id: this.gioObject?.storeId,
            md_code: this.storeInfo?.mdCode,
            third_platform: this.$route.query?.sharePlatform ? sharePlatform[this.$route.query?.sharePlatform] : 'null',
            share_id: this.$route.query?.shareId,
            share_user_id: this.uid,
            entrance: this.$route.query?.linkType ? entranceMap[this.$route.query?.linkType] : 'null',
            source_type: this.$route.query?.source_type || 'null',
            source_code: this.$route.query?.source_code || 'null',
          }, true)
        }
        // 二次分享
        this.$store.dispatch('WeChatSecondShare', {
          title: this.products.productFullName,
          desc: this.products.productTitle,
          // thumImage: `${this.swiperImgs[0].video ? this.swiperImgs[1] : this.swiperImgs[0]}`,
          thumImage: this.getShareImage(),
        })
        this.setStorageToShare()
        this.setgoodsDetailInfo({
          ...this.products,
          ...this.storeInfo
        })
      }).catch(e => {
        this.$toast.clear()
        console.log(e) 
      });
    },
    fnHb(hbIndex,payNum){
      this.hbIndex = hbIndex
      this.payNum = payNum
    },
    /**
     * @description app页面监听器
    */
    addListener() {
      if (this.$util.isHaierApp()) {
        instance.initDeviceReady().then(() => {
          instance.addResumeEventListener(() => {
            console.log('app resume  createIntersectionObserver=======> 0')

            // app 内重新激活页面时 重新监听元素曝光
            this.enterTime = new Date().getTime()
          }, 'onresume_key').catch(e=>console.log(e));
        }).catch(e => { console.log(e) });
      }
    },

    /** 显示预约到店弹窗 */
    showYyDialog(){
      if (!this.$store.getters.getLoginStatus) {
        this.$store.dispatch('doLogin')
        return
      }
      this.yyddDialogModal = true
    },
    closeYyDialog(){
      this.yyddDialogModal = false
      this.handleLocation()
    },
    /**
     * @description 切换 spu后刷新整个页面所有数据
     */
    fnSelectSpu(obj) {
      // 如果有视频实例 进行销毁 防止回退时无法实例化
      if (this.$refs?.swiper?.player) {
        this.$refs.swiper.player.dispose()
        this.$refs.swiper.player = null
        this.$refs.swiper.closeSmallVideo()
        this.$refs.swiper.isCancelSmallVideo = false
      }

      // const { query: _q } = this.$route
      // if (_q.exclusiveId) {
      //   this.queryExclusivePrice(_q.exclusiveId) // 查询专属价使用信息
      // }
      if (utils.isHaierApp()) {
        this.doShowUplusLive()
      }
      this.productId = obj.productId
      // this.visitStore = this.$route.query.visitStore
      // this.storeId = this.$route.query.storeId || '' // 分享人id
      // this.show_live = this.$route.query.show_live || ''
      this.relation()
      this.promos()
      this.specifications()
      this.evaluation()
      this.getCommentsByCondition()
      if (this.$util.isIhaierApp()) {
        // ihaier 显示分享按钮
        this.showShareFlag = true
      } else if (this.$util.isHaierApp()) {
        // U+ 显示分享按钮
        this.showShareFlag = true
        // U+ 登陆处理
        // const authFlag = await this.$store.dispatch('handleUpAuth')
        if (this.$store.getters.getLoginStatus) {
          this.getCartNumber()
        }
      } else {
        if (this.$store.getters.getLoginStatus) {
          this.getCartNumber()
        }
      }
      this.getProductBasicInfo().then(res1 => {
        this.productNumber = 1 // 切换spu时重置购买数量
        this.dynamic().then(res2 => {
          this.fetchHbFqInfo()
          // DSG-38576 白条分期信息屏蔽
          // this.fetchIoucCost()
          this.$util.gioTrackWithVariable('ProView', {
            member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
            user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
            deliverStreet: this.$store.state.locationInfo.township || 'null',
            deliverDistrict: this.$store.state.locationInfo.district || 'null',
            deliverCity: this.$store.state.locationInfo.city || 'null',
            deliverProvince: this.$store.state.locationInfo.province || 'null',
            storeId: this.gioObject.storeId ? this.gioObject.storeId + '' : 'null',
            stockStatus: this.gioObject.stockStatus ? this.gioObject.stockStatus + '' : 'null',
            productCode: this.gioObject.productEncode ? this.gioObject.productEncode + '' : 'null',
            productName_var: this.gioObject.productName || 'null',
            productId_var: this.gioObject.productId ? this.gioObject.productId + '' : 'null',
          })
          if (this.$util.isHaierApp()) {
            // 获取分享信息
            this.productQrCode()
          }
          // 二次分享
          this.$store.dispatch('WeChatSecondShare', {
            title: this.products.productFullName,
            desc: this.products.productTitle,
            // thumImage: `${this.swiperImgs[0].video ? this.swiperImgs[1] : this.swiperImgs[0]}`,
            thumImage: this.getShareImage(),
          })
          // spu切换 底部按钮刷新逻辑
          this.refreshSpuBtn()
          // 同步spu选中信息
          this.attrValueNames = obj.skuShortName
          this.attrLen = this.attrValueNames.length === 0 ? '' : this.attrValueNames.split(',').length
        }).catch(e => { console.log(e) });
      }).catch(e => { console.log(e) });
    },
    // 禁用标题长按选择
    notSelectTitle() {
      this.isCanSelectTitle = false
    },
    /**
     * @description 调起切换地址弹窗
     */
    changeAddress() {
      this.$refs.goodsInfo && this.$refs.goodsInfo.openAddr()
    },
    hiddenFeedBack() {
      this.showTotop = false
    },
    /*
     * @description spu商品弹窗内切换 ，按钮刷新
     */
    refreshSpuBtn() {
      // openFrom: 1, // 从何处打开的选择弹窗 1：已选 2：真实按钮
      // lastSelectRealBtn 0: 购物车
      if (this.openFrom === 1) {
        // 如果是点已选过来的，切换spu后按点已选逻辑刷新弹窗按钮
        this.refreshBtnType()
      } else {
        if (this.activityInfo && this.activityInfo.activityType === 81) {
          // 活动类型为立即预约的 弹窗按钮类型同步
          this.btnType = 8
        } else if (this.sgStockInfo.bookable) {
          // 点击真实按钮过来的，如果切换后商品为预定商品展示预定按钮 或定金尾款活动按钮
          if (this.activityInfo && this.activityInfo.activityType === 100) {
            if (this.activityInfo.deposit === 1) {
              if (this.lastSelectRealBtn === 4) {
                this.btnType = 4 // 原价购买
              } else {
                this.btnType = 5 // 支付定金
              }
            } else {
              this.btnType = 5 // 支付定金
            }
          } else if (this.activityInfo && this.activityInfo.activityType === 75) {
            // 拼团
            if (this.lastSelectRealBtn === 9) {
              this.btnType = 9
            } else {
              this.btnType = 10
            }
          } else {
            this.btnType = 3
          }
        } else {
          // 如果非预定商品 4 种情况
          // 0：购物车
          // 1：立即购买
          // 4：原价购买
          // 5：定金支付
          // 如果购物车按扭过来的 并且 允许展示购物车
          if (this.lastSelectRealBtn === 0 && this.baseInfo.supportCart && !this.hideCartBtn) {
            this.btnType = 0
          } else {
            if (this.activityInfo && this.activityInfo.activityType === 100) {
              if (this.activityInfo.deposit === 1) {
                if (this.lastSelectRealBtn === 4) {
                  this.btnType = 4 // 原价购买
                } else {
                  this.btnType = 5 // 支付定金
                }
              } else {
                this.btnType = 5 // 支付定金
              }
            } else if (this.activityInfo && this.activityInfo.activityType === 75) {
              // 拼团
              if (this.lastSelectRealBtn === 9) {
                this.btnType = 9
              } else {
                this.btnType = 10
              }
            } else {
              this.btnType = 1
            }
          }
        }
      }
    },
    /**
     * @description 单品页基本静态信息_new
     */
    attrSelectChanged() {},
    // 启用标题长按选择
    selectTitle() {
      this.isCanSelectTitle = true
    },
    /**
     * @description 商品标题复制控制
     */
    titleSelectOption(v) {
      this.isCanSelectTitle = v
    },
    countdownFinish() {
      this.exclusiveFinished = true // 专属价计时结束
    },
    queryExclusivePrice(exclusiveId) {
      queryExclusivePrice({
        id: exclusiveId,
      }).then(res => {
        if (res.success) {
          const current = res.data[0]
          this.exclusiveUsed = current.used // 专属价已使用
        } else {
          this.$message.error(res.message)
        }
      }).catch(e => console.log(e))
    },
    attrNameChange(v) {
      this.attrValueNames = v
      this.attrLen = this.attrValueNames.length === 0 ? '' : this.attrValueNames.split(',').length
      this.attrValueNames = v.length === 0 ? this.holdSelected : this.attrValueNames
    },
    verifyTagCheckStatus() {
      if(this.skku) return true
      if (!(this.sgAttribute && this.sgStoreAttribute)) {
        // 非多规格不验证
        return true
      }
      // 多规格需要验证规格标签是否选择完整
      if (this.attrLen < Object.keys(this.sgAttribute).length) {
        return false
      }
      return true
    },
    /**
     * 回到顶部
     */
    toGotop() {
      // this.$refs.scrollBox.scroll({
      //   top: 0,
      //   behavior: 'smooth'
      // })
      this.showTotop = false
      this.scrollSmoothTo(0)
    },
    /**
     * 模拟动画滚动
     */
    scrollSmoothTo(position) {
      console.log('#scrollSmoothToscroll')
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback) {
          return setTimeout(callback, 17)
        }
      }
      // debugger
      let _target = document.querySelector('.inner-view')
      // 返回顶部前禁止滑动，防止scroll事件冲突导致页面重新布局
      const handleTouchMove = e => e.preventDefault()
      _target.addEventListener('touchmove', handleTouchMove)
      // 当前滚动高度
      let scrollTop = _target?.scrollTop || 0
      console.log(scrollTop, 'scrollTop')
      // 滚动step方法
      let step = function() {
        // 距离目标滚动距离
        var distance = position - scrollTop
        // 目标滚动位置
        scrollTop = scrollTop + distance / 5
        if (Math.abs(distance) < 1) {
          _target?.scrollTo && _target.scrollTo(0, position)
          _target.removeEventListener('touchmove', handleTouchMove)
        } else {
          _target?.scrollTo && _target.scrollTo(0, scrollTop)
          requestAnimationFrame(step)
        }
      }
      step()
    },
    handleScroll(e) {
      if (this.cancelScroll) {
        return
      }
      this.showTotop = false
      this.$util.throttle(() => {
        const htmlFontSize = this.$util.getHtmlFontSize()
        this.navShowFlag = this.$refs.scrollBox?.scrollTop > htmlFontSize * 0.92
        let _gcTop = Math.abs(this.$refs.goodsContainer?.getBoundingClientRect().top)
        let _dcTop = this.showComment ? Math.abs(this.$refs.detailContainer?.getBoundingClientRect().top) : 0;
        let _ccTop = this.showComment ? Math.abs(this.$refs.commentContainer?.getBoundingClientRect().top) : 0;
        let _glTop = this.$refs.guessLikeContainer?.getBoundingClientRect().top;
        this.scrollTop = _gcTop;

        if (!this.showComment) {
          let scrollHeight = e.target.scrollHeight // div里内容的高度，根据内容的增加和减少变化
          let scrollTop = e.target.scrollTop // 滚动条的最上端到，div上端内里框框的高度
          let clientHeight = e.target.clientHeight // div内里框框的高度，是死的
          if (scrollHeight - clientHeight === scrollTop) {
            this.showComment = true
          }
        }
        if (this.$refs?.scrollBox?.scrollTop > 200) {
          this.canShowTotop()
        } else {
          clearInterval(this.canShowTotopInterval)
          this.canShowTotopInterval = null
        }
        this.$nextTick(() => {
          if (_glTop < 90) {
            this.activeAnchor = 'guessLikeContainer'
          } else if (_gcTop < _dcTop && _gcTop < _ccTop) {
            this.activeAnchor = 'goodsContainer'
          } else if (_dcTop < _gcTop && _dcTop < _ccTop) {
            this.activeAnchor = 'detailContainer'
          } else if (_ccTop < _dcTop && _ccTop < _gcTop) {
            this.activeAnchor = 'commentContainer'
            if (!this.showComment) {
            }
          }
        })
      }, 200)()
    },
    /**
     * 滚动停止后再显示返回顶部
     */
    canShowTotop () {
      if (this.canShowTotopInterval === null) {
        this.canShowTotopInterval = setInterval(() => {
          console.log('检查是否显示返回顶部');
          const scrollBoxScrollTop = this.$refs.scrollBox?.scrollTop
          if (scrollBoxScrollTop === this.preScrollBoxScrollTop && scrollBoxScrollTop > 200) {
            this.showTotop = true
            clearInterval(this.canShowTotopInterval)
            this.canShowTotopInterval = null
          } else {
            this.preScrollBoxScrollTop = scrollBoxScrollTop
          }
        }, 200)
      }
    },
    ...mapActions(['getCartNumber', 'addCart']),
    // 调用直播
    doShowUplusLive() {
      let isShowLive = this.$route.query.show_live
      if (+isShowLive && !sessionStorage.getItem('showlive')) {
        instance.initDeviceReady().then(() => {
          instance.upLiveModule.showFloatWindow()
        }).catch(e => { console.log(e) });
      }
    },

    /**
     * 通过skus获取当前是否有直播
     */
    getSkusLive(sku) {
      getSkusLiveInfo([sku]).then(res => {
        let result = res.data
        console.log(result, '++++result++++')
        this.hotLiveInfo = result?.[sku] || []
      }).catch(e => { console.log(e) });
    },
    /**
     * 访问直播页面
     */
    doOpenLive(info) {
      console.log(info)
      if (this.$util.isHaierApp()) {
        let isShowLive = this.$route.query.show_live
        if (isShowLive) {
          instance.initDeviceReady().then(() => {
            instance.upLiveModule.closeFloatWindow().catch(e => { console.log('清除浮动窗口失败', e); })
            instance.upVdnModule.goToPage({ url: this.$util.isIos() ? info.appIosUrl : info.appAndroidUrl })
          }).catch(e => { console.log('初始化设备失败', e); })
        } else {
          instance.initDeviceReady().then(() => {
            instance.upVdnModule.goToPage({ url: this.$util.isIos() ? info.appIosUrl : info.appAndroidUrl })
          }).catch(e => { console.log('初始化设备失败', e); })
        }
      } else {
        getUcLoginUrl({
          redirectUri: info.h5Url,
          target: userKeyTarget.LiveTarget,
          targetTest: userKeyTarget.LiveTarget_test,
          redirectUriTest: info.h5Url,
        }).then(({ data }) => {
          if (data.success) {
            location.href = data.data
          } else {
            this.$toast(data.message)
          }
        }).catch(e => console.log(e))
      }
    },

    /**
     * @description 单品页基本静态信息_new
     */
    getProductBasicInfo() {
      return new Promise((resolve, reject) => {
        getProductBasicInfo({
          productId: this.productId,
          channel: '',
          openId: '',
          storeId: this.visitStore || '', // 分享人id
          mdCode: this.mdCode || '',
          sceneCode: this.$route.query.fkcode || '',
          directCode: this.$route.query.directCode || '',
        }).then(res => {
          if (res.success) {
            this.shopInfo = res
            this.productTypeId = res.data.products.productTypeId
            this.hasSubProduct = !!res.data.sgStoreAttribute[0].haschildItems
            if (this.hasSubProduct) {
              if (this.skku) {
                // 多规格 参与限时抢购商品 进入单品页默认选中 活动规格 价格最低的规格组合
                res.data.sgStoreAttribute.forEach(i => {
                  if (i.skku === this.skku) {
                    this.shopInfo.data.checkedAttr = i.attrValueIds
                  }
                })
              } else {
                // this.shopInfo.data.checkedAttr = ''
                // 如果是有优惠券的且多规格商品默认选中 this.shopInfo.data.checkedAttr 的商品
                let defaultItem = this.shopInfo.data.sgStoreAttribute.filter(item => item.attrValueIds === this.shopInfo.data.checkedAttr)[0]
                console.log(defaultItem, 'defaultItem')
                if (defaultItem) {
                  this.sku = defaultItem.sku
                  this.skku = defaultItem.skku
                  this.dynamic()
                }
              }
            } else {
              // 非多规格，规格标题统一为型号
              this.shopInfo.data.sgAttribute['0'][0].attrName = '型号'
              this.shopInfo.data.sgAttribute['0'][0].sgAttribute.attrName = '型号'
              // 单规格商品默认规格选中，不可取消
              this.attrHasSelect = true
              // 非多规格 默认选中
              this.shopInfo.data.checkedAttr = '0'
            }

            this.$set(this.gioObject, 'productName', res.data.products.productFullName)
            this.$set(this.gioObject, 'productId', String(res.data.products.productId))
            this.$set(this.gioObject, 'productEncode', res.data.products.sku)
            this.isCollected = res.data.isCollected // 是否收藏，1收藏0没收藏
            this.products = res.data.products

            // 如果是多规格商品且默认url中带有skku参数，对products进行挂载
            if (this.skku) {
              this.products.skku = this.skku
            }

            this.swiperSkeleton = false
            resolve()
          } else {
            this.$toast(res.message)
          }
        }).catch(e => console.log(e))
      })
    },
    /**
     * @description 获取商品所属 squ 组信息
     */
    getVirtualSpuInfo(pid) {
      if (this.$route.query.exclusiveId) {
        return Promise.resolve()
      } else {
        return new Promise((resolve, reject) => {
          getVirtualSpuInfo({
            productId: pid,
          }).then(res => {
            if (res.success) {
              this.spuInfo = res.data
              if (this.spuInfo) {
                this.spuInfo.spuSpecsList[0].spuSkuList.forEach(i => {
                  if (i.productId === Number(pid)) {
                    this.attrValueNames = i.skuShortName
                  }
                })
              }
              resolve()
            } else {
              this.$toast(res.message)
            }
          }).catch(e => console.log(e))
        })
      }
    },
    /**
     * @description 处理静态接口中的多规格数据
     */
    calcAttr() {
      let res = this.shopInfo
      let _checkedAttrIds = []
      let _attrValueNames = []
      let _checkedAttrKeys = []
      let _checkedAttr = {}
      if (res.data.checkedAttr) {
        this.checkedAttr = res.data.checkedAttr
        _checkedAttrIds = res.data.checkedAttr.split(',')
        _checkedAttrKeys = Object.keys(res.data.sgAttribute)
        _checkedAttrKeys.forEach((item, index) => {
          _checkedAttr[item] = _checkedAttrIds[index]
        })
      }
      // 针对多规格与单规格特殊处理，单规格默认选中，多规格默认不选中 初始化显示规格标题拼接
      // 活动多规格默认选中 默认显示选中规格
      if (this.hasSubProduct && !this.checkedAttr) {
        // 多规格处理
        for (let key in res.data.sgAttribute) {
          _attrValueNames.push(res.data.sgAttribute[key][0].attrName)
        }
      } else {
        // 单规格处理
        for (let key in res.data.sgAttribute) {
          res.data.sgAttribute[key].forEach((item, index) => {
            if (item.sgAttribute.id === _checkedAttr[key] * 1) {
              item.selected = true
              _attrValueNames.push(item.sgAttribute.attrValueName)
            } else {
              item.selected = false
            }
          })
        }
      }
      if (!this.spuInfo) {
        this.attrValueNames = _attrValueNames.join(',')
      }
      this.holdSelected = _attrValueNames.join(',')

      if (this.hasSubProduct) {
        // 多规格情况 因为默认不选中， 选中规格长度手动置空
        // 活动多规格默认选中 规格长度按默认配置计算
        this.attrLen = this.checkedAttr ? this.attrValueNames.split(',').length : 0 // 初始化的时候算一下长度
      } else {
        // 单规格走老逻辑
        this.attrLen = this.attrValueNames.split(',').length // 初始化的时候算一下长度
      }

      this.sgAttribute = res.data.sgAttribute
      this.sgStoreAttribute = res.data.sgStoreAttribute
      this.originAttrs = res.data.sgStoreAttribute ? res.data.sgStoreAttribute.filter((v, i) => v.num >= 0) : []
      if (res.data.sgStoreAttribute) {
        res.data.sgStoreAttribute.forEach(item => {
          if (this.checkedAttr === item.attrValueIds) {
            this.sgStoreAttributeItem = item
            this.skku = item.skku
            // this.productNumber = item.num ? 1 : 0
          }
        })
      } else {
        this.sgStoreAttributeItem = null
      }
    },
    /**
     * @description 单品页动态信息接口_new
     */
    dynamic() {
      cancelToken()
      const { query: _q } = this.$route
      this.baseInfo.showStockNum = false
      this.productNumber = 1
      return new Promise((resolve, reject) => {
        dynamic({
          prodId: this.productId,
          mdCode: this.mdCode || '',
          directCode: this.$route.query.directCode || '',
          // channel: '',
          memberStoreId: this.getShareId || '',
          number: this.productNumber || 1, // 不能传0
          // number: 1, // 不能传0
          provinceId: this.location.provinceId,
          cityId: this.location.cityId,
          regionId: this.location.districtId,
          streetId: this.location.townshipId,
          latitude: this.location.latitude,
          longitude: this.location.longitude,
          skku: this.skku || null,
          sku: this.products?.sku || null, 
          visitStore: this.visitStore,
          exclusivePriceId: _q.exclusiveId || null,
          directSaleType: _q.directSaleType || null,
          sceneCode: _q.sceneCode || null,
          sceneVersion: _q.sceneVersion || null,
          // 分佣逻辑参数
          comId: _q.comId,
          // ft / fk标志   1代表ft（套购）
          sceneType: _q.sceneType || 0,
          sourceType: sessionStorage.getItem('sc_source_type') || '',
          externalSource: this.sourceTypeAndCode.sourceType === 'GYYXMF' ? 2 : '',
          scene: _q.scene || '',

        }, { cancelToken: new this.$http.CancelToken(c => { cancelToken = c }) }).then(async res => {
          if (res.success) {
            this.dynamicInfo = res.data
            this.activityInfo = res.data.activityInfo || {} // 活动信息，为空时没有参与活动，非必返回，有返回值时替换原有活动内容
            this.baseInfo = {
              ...res.data.baseInfo,
              showStockNum: false
            } // 基础信息，必定返回
            this.priceInfo = res.data.priceInfo || {} // 价格信息对象，必定返回
            // console.log(this.priceInfo, 'aaaaaaaaaaaaaaaaaaa')

            // 头图活动元素信息，没有活动元素时为null
            this.firstImageInfo = res.data.firstImageInfo

            this.noticeContent = res.data.noticeInfo // 优先使用paltformNoticeContent
              ? res.data.noticeInfo.platformNoticeContent
                ? res.data.noticeInfo.platformNoticeContent
                : res.data.noticeInfo.storeNoticeContent
                  ? res.data.noticeInfo.storeNoticeContent
                  : undefined
              : undefined
            this.sgStockInfo = res.data.sgStockInfo ? { ...res.data.sgStockInfo } : {} // 库存信息，必定返回
            // if (this.sgStockInfo) { this.sgStockInfo._hideStockNum = this.hideStockNum }
            this.storeInfo = res.data.storeInfo || null // 店铺信息，不一定返回
            if (this.storeInfo) {
              // storeInfo存在的话获取商品所属店铺id
              this.staticStoreId = res.data.storeInfo.o2oStoreId
            } else {
              this.staticStoreId = ''
            }
            // 埋点库存状态
            let stockStatus = ''
            if (this.sgStockInfo.hasStock) {
              stockStatus = '有货'
            } else {
              stockStatus = '无货'
            }
            // 店铺id
            if (res.data.storeInfo === null) {
              this.o2oStoreId = ''
            } else {
              this.o2oStoreId = res.data.storeInfo.o2oStoreId
            }
            this.$set(this.gioObject, 'stockStatus', stockStatus)
            this.$set(this.gioObject, 'storeId', this.o2oStoreId)
            /**
             * 轮播图展示顺序：
             * 1.活动图->baseInfo.image(来自动态接口)
             * 2.视频->products.videoUrl(来自静态接口)
             * 3.素材图->firstImageInfo.images[0](来自动态接口)
             * 4.原图->shopInfo.data.swiperImgs(来自静态接口)
             * 
             * 在活动图>素材图>原图之间，
             * 只要活动图存在，firstImageInfo.firstImageType=1 
             * 否则，只要素材图存在，firstImageInfo.firstImageType=2
             * 否则，仅剩原图存在，firstImageInfo.firstImageType=3
             */
            if (this.baseInfo.image) {
              if (this.swiperImgs && this.swiperImgs[0] && this.swiperImgs[0].baseImage) {
                this.swiperImgs[0].baseImage = this.baseInfo.image
              } else {
                this.swiperImgs = [{ baseImage: this.baseInfo.image || '' }, ...this.shopInfo.data.swiperImgs]
              }
              if (this.products.videoUrl) {
                // debugger
                let videoUrl = this.$util.strJSONParse(this.products.videoUrl, { video: this.products.videoUrl })
                this.swiperImgs = [
                  { baseImage: this.swiperImgs[0].baseImage },
                  {
                    img: videoUrl.img,
                    video: (this.$util.isM3U8Supported() && videoUrl.m3u8Video) ? videoUrl.m3u8Video : videoUrl.video,
                  },
                  ...this.shopInfo.data.swiperImgs,
                ]
              }
              // 如果有素材图则插入
              if (this.firstImageInfo?.firstImageType === 2 && this.firstImageInfo?.images.length) {
                this.swiperImgs.splice(1, 0, this.firstImageInfo.images[0])
              }
            } else {
              if (this.products.videoUrl) {
                let videoUrl = this.$util.strJSONParse(this.products.videoUrl, { video: this.products.videoUrl })
                this.swiperImgs = [
                  {
                    img: videoUrl.img,
                    video: (this.$util.isM3U8Supported() && videoUrl.m3u8Video) ? videoUrl.m3u8Video : videoUrl.video,
                  },
                  ...this.shopInfo.data.swiperImgs,
                ]
              } else {
                this.swiperImgs = this.shopInfo.data.swiperImgs
              }
              // 如果有素材图则插入
              if (this.firstImageInfo?.firstImageType === 2 && this.firstImageInfo?.images.length) {
                this.swiperImgs.splice(0, 0, this.firstImageInfo.images[0])
              }
            }
            // 初始化商品选中数量
            // if (!(this.sgAttribute && this.sgStoreAttribute)) {
            //   this.productNumber = (this.sgStockInfo.stockNum || this.sgStockInfo.stockNum === 0) ? 1 : 0
            // }

            // TODO 处理多规格逻辑
            // 如果是单规格预定商品 模拟 500库存
            // if (this.sgStockInfo.bookable && this.sgStockInfo.stockNum === 0 && !this.hasSubProduct) {
            //   // this.sgStockInfo.stockNum = 500
            // }
            await this.getsgStoreAttributeStockNum()
            console.log(this.shopInfo, 'shopInfo=>')

            // 1.如果是无子商品多规格，获取动态接口的价格与库存，有子商品不做处理
            if (!this.hasSubProduct) {
              this.shopInfo.data.sgStoreAttribute[0].num = this.sgStockInfo.stockNum
              if (this.activityInfo && this.activityInfo.activityType === 100) {
                this.shopInfo.data.sgStoreAttribute[0].price = this.priceInfo.originPrice
              } else {
                this.shopInfo.data.sgStoreAttribute[0].price = this.priceInfo.actualPrice
              }
            }
            if (!this.attrInitStatus) {
              // // 1.如果是无子商品多规格，获取动态接口的价格与库存，有子商品不做处理
              // if (!this.hasSubProduct) {
              //   this.shopInfo.data.sgStoreAttribute[0].num = this.sgStockInfo.stockNum
              //   if (this.activityInfo && this.activityInfo.activityType === 100) {
              //     this.shopInfo.data.sgStoreAttribute[0].price = this.priceInfo.originPrice
              //   } else {
              //     this.shopInfo.data.sgStoreAttribute[0].price = this.priceInfo.actualPrice
              //   }
              // } else {
              //   // 验证 主商品 是否马上预定的 多规格商品
              //   // 多规格商品 进入页面时 主商品可预订 则所有子商品可预订
              //   if (this.sgStockInfo.bookable) {
              //     this.parentBookable = true
              //   }
              // }
              // 2.处理多规格数据
              this.calcAttr()
              // DSG-38576 白条分期信息屏蔽
              // this.fetchIoucCost()
              this.attrInitStatus = true
              // 3.处理spu数据
              // this.spuInfo = res.data.virtualSpuInfo
              if (this.spuInfo) {
                this.spuInfo.spuSpecsList[0].spuSkuList.forEach(i => {
                  if (i.productId === Number(this.productId)) {
                    this.attrValueNames = i.skuShortName
                  }
                })
              }
            }

            // 复购分佣
            if (res.data.storeInfo) {
              this.fetchRecordShareRelation()
              if (res.data.storeInfo.mdCode) {
                this.getGuiderList()
              }
            }
            this.getSkusLive(this.products.productId) // 获取直播信息
            //以旧换新 v2
            this.fetchRenewedInfo()
            
            this.fetchHbFqInfo()
            // this.fetchIoucCost()
            // 设置优惠券信息
            this.getProductAvailableCoupons().then(res => {
              // 获取plus会员注册入口相关数据
              this.getPlusEntrance()
            })
            this.querySingleOnlineRightsList()
            // 设置礼品券信息
            this.getGiftCouponListByStoreAndSku()
            // 凑单折扣信息
            this.setDiscountActivityInfo(res?.data?.discountActivityInfo)
            // 加载完成
            this.isSkeletonLoading = true
            Promise.all([lazyGoodsDetail(), lazyCommentInfo(), lazyShopInfo()]).then(() => {
              this.showComment = true
              console.log('====================================')
              console.log('加载完成')
              console.log('===================================')
            }).catch(e => { console.log(e) });

            resolve()
          } else {
            this.$toast(res.message)
          }
        }).catch(e => {
          this.isSkeletonLoading = true
        })
      })
    },

    /**
     * 动态获取商品库存信息
     */
    getsgStoreAttributeStockNum() {
      const sceneCode = 
      this.$route.query.fkcode 
        ? this.$route.query.fkcode 
        : this.$route.query.sceneCode 
          ? this.$route.query.sceneCode
          : undefined
      return this.$http.post(URL.getStock, {
        sku: this.products.sku,
        storeId: this.storeInfo?.o2oStoreId,
        stockType: this.sgStockInfo?.stockType,
        streetId: this.location.townshipId,
        supplierCode: this.sgStockInfo?.vcode,
        sceneCode: sceneCode,
        directCode: this.$route.query.directCode || '',
      }, {
        baseURL: config.DHOST,
      }).then(res => {
        let result = res.data
        console.log('getsgStoreAttributeStockNum===>', result)
        result.data.forEach(item => {
          this.shopInfo.data.sgStoreAttribute.forEach(itm => {
            if (+itm.attrValueIds === +item.attrValueIds) {
              // 此处数量仅用于控制子规格商品是否可选，需求修改需要控制当库存为0时，子规格商品也可选
              itm.num = item.num || 1
            }
          })
        })
        this.baseInfo.showStockNum = true
        // this.shopInfo.data.sgStoreAttribute = result
      }).catch(e => {
        this.baseInfo.showStockNum = true
        console.log(e)
      })
    },
    /**
     * @description 商品可用优惠券（单品页）
     */
    getProductAvailableCoupons() {
      return new Promise((resolve, reject) => {
        getProductAvailableCoupons({
          // productId: this.productId,
          sku: this.skku || this.products.sku || '',
          storeId: this.storeInfo ? this.storeInfo.o2oStoreId : null, // 商家id，动态信息接口有店铺时传，其他时候不传
          price: this.trulyPrice, //this.priceInfo ? (this.priceInfo.priceType === 100 ? this.priceInfo.finalPrice : this.priceInfo.actualPrice) : null, // 价格，动态信息接口priceType=100取finalPrice，其他情况取actualPrice
          mdCode: this?.storeInfo?.mdCode || '',
          brandId: this.products.brandId,
          departmentCode: this.products.department || '',
        }).then(res => {
          if (res.success) {
            this.finishedCoupon = true
            if (res.data) {
              // res.data -> res.data.filter 
              const canGetCoupons = res.data.filter(item => item.productUsingCouponType !== 1)
              const canUseCoupons = res.data.filter(item => item.productUsingCouponType === 1)
              if (canGetCoupons.length > 2) {
                this.couponList = canGetCoupons.slice(0, 2)
              } else if (canGetCoupons.length > 0){
                this.couponList = res.data
              } else if (canUseCoupons.length) {
                // 没有可领券，如果有可用券则展示可用券逻辑
                this.couponCanUseList = canUseCoupons
              }
            } else {
              this.couponList = []
            }
            this.voucherList = res.data ? res.data : []
          } else {
            // this.$toast(res.message)
            console.log(res.message)
          }
          resolve()
        }).catch(e => console.log(e))
      })
    },
    /**
     * @description 商品可用礼品券（单品页）
     */
    getGiftCouponListByStoreAndSku() {
      let data = {
        shopAndSkuList:[{
          productCode: this.skku || this.products.sku || '',
          storeId: this.storeInfo ? this.storeInfo.o2oStoreId : null, // 商家id，动态信息接口有店铺时传，其他时候不传
          mdCode: this?.storeInfo?.mdCode || '',
        }]
      }
      return new Promise((resolve, reject) => {
        getGiftCouponListByStoreAndSku(data).then(res => {
          res = res.data
          if (res.success) {
            this.finishedCouponGift = true
            this.couponGiftData = res.data ? res.data : []
            if (this.couponGiftData.length) {
              this.couponGiftList = this.couponGiftData[0].couponList.slice(0, 2)
            } else {
              this.couponGiftList = []
            }
            this.voucherGiftList = this.couponGiftData.length > 0 ? this.couponGiftData[0].couponList : []
            resolve()
          } else {
            // this.$toast(res.message)
            console.log(res.message)
          }
        }).catch(e => console.log(e))
      })
    },
    /**
     * @description 获取商品权益
     */
    querySingleOnlineRightsList() {
      if (this.priceInfo && this.priceInfo.actualPrice && this.storeInfo && this.storeInfo.storeCode) {
        // 获取商品权益
        querySingleOnlineRightsList({
          productCode: this.products.sku,
          // storeId: this.storeInfo.o2oStoreId,
          mdCode: this.storeInfo.mdCode,
          productPrice: this.priceInfo.actualPrice,
          sourceType: this.sourceTypeAndCode.sourceType || '',
        }).then(res => {
          if (res && res.success && res.data) {
            this.rightsList = res.data
          } else {
            this.rightsList = []
          }
        }).catch(() => {
          this.rightsList = []
        })
      } else {
        this.rightsList = []
      }
    },
    receiveToast(status, time) {
      // console.log(time)
      // const icon = status ? require('@/assets/imgs/cart/icon-receive-success.png') : require('@/assets/imgs/cart/icon-receive-error.png')
      const message = status ? '领取成功' : '领取失败'
      this.$toast({ message, duration: 1500 })
      // if (time) {
      //   this.$nextTick(() => {
      //     const wrapper = document.querySelector('.van-toast')
      //     if (wrapper.querySelectorAll('.toast-add-text').length) {
      //       return
      //     }
      //     const text = document.createElement('span')
      //     text.className = 'toast-add-text'
      //     text.innerHTML = `${time}可用`
      //     wrapper.appendChild(text)
      //     const removeTimer = window.setTimeout(() => {
      //       wrapper.removeChild(text)
      //       window.clearTimeout(removeTimer)
      //     }, 1550)
      //   })
      // }
    },
    /**
     * @description 领取优惠券
     */
    receiveCoupon(data) {
      console.log(data, '++++++++=============++++++++++')
      const streetId = this.location.townshipId
      let voucherKey = 'voucherList'
      if (data.couponType === 'REALITY_GIFT_COUPON') {
        voucherKey = 'voucherGiftList'
      }
      receiveCoupon({
        activityCode: data.activityCode,
        couponTemplateCode: data.couponTemplateCode,
        sourceChannel: data.sourceChannel,
        streetId,
        receiveMdCode: this.storeInfo?.mdCode,
      }).then(res => {
        if (res.success) {
          this[voucherKey][data.index].displayType = '2'
          this[voucherKey] = [...this[voucherKey]]
          this.receiveToast(true, data.startTime && data.endTime ? `${data.startTime}-${data.endTime}` : '')
          // 计算可用券是否都领取过
          console.log(this.checkCouponIsAllGet)
          // this.$toast(res.message)
          const currentRole = this.$store.getters['mymanage/getCurrentRole'] // computed(() => store.getters['mymanage/getCurrentRole'])
          const currentRoles = this.$store.getters['mymanage/getUserRoles']
          let currentRoleOne
          if (currentRoles.size) {
            currentRoleOne = Array.from(currentRoles)[0]
          }
          this.$util.trackWithVariable({
            platformConf: {
              [PlatformTypes.COMMON]: {
                id: 'MB33864',
                param: ['ad_coupon_act_id', 'ad_coupon','ad_coupon_id','coupon_code','md_code','store_code','sku_code','product_id','product_name','user_type'],
              }
            },
          }, {
            'ad_coupon_act_id':data.activityCode,
            'ad_coupon':data.couponTemplateName,
            'ad_coupon_id':data.couponTemplateCode,
            'coupon_code':res.data.couponCode,
            'md_code':this.storeInfo?.mdCode,
            'store_code':this.storeInfo?.storeCode,
            'sku_code': this.skku || this.products.sku || '',
            'product_id': this.productId,
            'product_name': this.products.productFullName,
            'user_type': currentRole ? (currentRole?.userIdentity || null) : currentRoleOne,
          }).then(res => {
            console.log('report res', res)
          })
        } else {
          this[voucherKey][data.index].displayType = '5'
          this.$toast(res.message)
          // this.receiveToast(false)
        }
      }).catch(e => console.log(e))
    },
    fnSelectAttribute(item, stepperNum) {
      console.log('change')
      this.$refs?.swiper?.player?.dispose?.()
      if (this.$refs?.swiper?.player) this.$refs.swiper.smallVideoShow = false
      this.sgStoreAttributeItem = item
      this.skku = item.skku
      this.productNumber = stepperNum
      // 重新请求商品信息，更新数据
      if (this.$route.query.exclusiveId) this.queryExclusivePrice(this.$route.query.exclusiveId)
      this.dynamic().then(r => {
        // 刷新弹窗底部按钮 非立即购买/马上预定/加入购物车 则根据接口逻辑刷新按钮
        if (this.btnType !== 0 && this.btnType !== 1 && this.btnType !== 3) {
          this.refreshBtnType()
        }
      }).catch(e => { console.log(e) });
    },
    /**
     * @description 获取服务说明
     */
    getDes() {
      let _sidArr = this.sgStockInfo.labels.map(item => item.i)
      getDes({
        sid: `${_sidArr.join(',')},`,
      }).then(res => {
        if (res.success) {
          this.descriptionList = [...res.data]
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    /**
     * @description 单品页关联商品接口
     */
    relation() {
      relation({
        productId: this.productId,
      }).then(res => {
        if (res.success) {
          this.relationList = res.data || []
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    /**
     * @description 单品页图文详情接口_new
     */
    promos() {
      promos({
        productId: this.productId,
      }).then(res => {
        if (res.success) {
          this.mp4FileId2 = res.data ? res.data.mp4FileId2 : ''
          this.sgTopPic = res.data ? (res.data.sgTopPic ? res.data.sgTopPic.pic : '') : ''
          this.productDetails = res.data ? res.data.productDetails : ''
          this.productDetails = this.productDetails.replace(/<a.*?(?:>)([\s\S]*?)<\/a>/gi, '') // 去掉a标签
          this.productDetails = this.productDetails.replace(/<br>/gi, '') // 去掉<br>标签
          this.productDetails = this.productDetails.replace(/http:/gi, '') // 替换http
          this.richText = res.data ? res.data.richText : ''
          this.richText = this.richText.replace(/<a.*?(?:>)([\s\S]*?)<\/a>/gi, '') // 去掉a标签
          this.richText = this.richText.replace(/<br>/gi, '') // 去掉<br>标签
          this.richText = this.richText.replace(/http:/gi, '') // 替换http
          this.sgBottomPic = res.data ? (res.data.sgBottomPic ? res.data.sgBottomPic.pic : '') : ''
          this.afterSales = res.data ? res.data.afterSales : ''
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    /**
     * @description 单品页规格参数接口
     */
    specifications() {
      specifications({
        productId: this.productId,
      }).then(res => {
        if (res.success) {
          this.productAttrs = res.data ? res.data.productAttrs : []
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    /**
     * 获取花呗分期的信息
     */
    async fetchHbFqInfo() {
      try {
        const result = await getActivityInfoByScene({
          paySourceId: getOrderPaySourceIdByEnv(),
          // fkCode: this.$route.query.fkcode || '',
          sourceType: this.sourceTypeAndCode.sourceType || '',
          installmentTypeList: ['ali_huabei', 'xj_pay'],
          amount: this.activityInfo ? this.priceInfo.finalPrice : this.priceInfo.actualPrice,
          productList: [
            {sku: this.products.sku, mdCode: this.storeInfo.mdCode, isScene: !!this.$route.query.fkcode}
          ]
        })
        // console.log('aaaaaaaaaaaaaa=>',result)
        const { success, data  } = result
        if(success){
          this.hbFqInfo = data[0].installmentList
          if (data[1]) {
            this.xjFqInfo = data[1].installmentList
          }
        }
      } catch (error) {
      
      }
      // var price = 0
      // if (this.activityInfo) {
      //   price = this.priceInfo.finalPrice
      // } else {
      //   price = this.priceInfo.actualPrice
      // }
      // this.$http.get(URL.ALIPAY_CREDITPAY_BY, {
      //   params: {
      //     amount: price,
      //     sku: this.products.sku,
      //   }
      // }).then(res => {
      //   let result = res.data;
      //   console.log('fetchHbFqInfo===>', result)
      //   if (result.success) {
      //     this.hbFqInfo = result.data
      //   }
      // }).catch(e => { console.log(e) });
    },
    // /**
    //  * @description 获取白条分期的信息
    //  */
    // fetchIoucCost() {
    //   // if (utils.isNull(this.accessToken) || utils.isNull(this.ucId)) {
    //   //   // this.$toast('您的当前帐号暂时无法访问此服务,请使用关联手机号登录')
    //   //   return
    //   // }
    //   var price = 0
    //   if (this.activityInfo) {
    //     price = this.priceInfo.finalPrice
    //   } else {
    //     price = this.priceInfo.actualPrice
    //   }
    //   getIoucCost({
    //     payAmt: price,
    //     proGroup: this.products.department,
    //     sku: this.skku ? this.skku : this.products.sku,
    //     token: this.accessToken,
    //   }).then(res => {
    //     if (res.success) {
    //       this.ioucInfo = res.data // { 'crdComAvailAmt': '100', 'costInfo': [{ 'rate': 0.65, 'fee': 3.24, 'num': 3, 'eachPrinAndFee': 169.57 }, { 'rate': 0.65, 'fee': 3.24, 'num': 6, 'eachPrinAndFee': 86.41 }, { 'rate': 0.65, 'fee': 3.24, 'num': 12, 'eachPrinAndFee': 44.82 }], 'feeInfo': '', 'applyStatus': '3' }//
    //     } else {
    //       // this.$toast(res.message)
    //     }
    //   })
    // },
    goBaitiao() {
      if (!this.ioucInfo) return
      switch (this.ioucInfo.applyStatus) {
        case '2':
        case '3':
        // 去申请
          this.$router.push({
            path: '/sgwhitepay',
          })
          break
        case '0':
        // 申请中
        // console.log('----------', URL.WHITE_SHOWS_APPLY)
          this.$http
            .get(URL.WHITE_SHOWS_APPLY, {
              params: {
                backUrl: window.location.href,
                userId: this.ucId,
                token: this.accessToken,
              },
            })
            .then(res => {
              let result = res.data
              if (result.success) {
                console.log(result.data.redirectUrl)
                location.href = result.data.data.url
              }
            }).catch(e => { console.log(e) });
          break
        case '1':
        // 查看额度
          break
        default: {
        // console.log(this.ioucInfo.applyStatus)
        }
      }
    },
    /**
     * @description 商品评价 获取评价数好评率
     */
    evaluation() {
      evaluation({
        productId: this.productId,
      }).then(res => {
        if (res.success) {
          this.commentTotal = res.data.commentTotal
          this.positiveRate = res.data.positiveRate // 按后台返回展示实际好评率
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    /**
     * @description 商品评价详情接口
     */
    getCommentsByCondition() {
      getCommentsByCondition({
        commentType: 'all',
        productId: this.productId,
        pageSize: 2,
        pageIndex: 1,
      }).then(res => {
        if (res.success) {
          this.commentList = this.fnFormatComment(res.data)
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    // /**
    //  * @description 切换spu商品时刷新评价
    //  */
    // refreshCommentsByCondition() {
    //   getCommentsByCondition({
    //     commentType: 'all',
    //     productId: this.productId,
    //     pageSize: 2,
    //     pageIndex: 1,
    //   }).then(res => {
    //     if (res.success) {
    //       this.commentList = this.fnFormatComment(res.data)
    //     } else {
    //       this.$toast(res.message)
    //     }
    //   })
    // },
    /**
     * @description 处理评论内容  超长截取
     */
    fnFormatComment(commentList = []) {
      if (commentList.length === 0) {
        return []
      }
      commentList.forEach(item => {
        // 评论
        if (item.commentContent.length > 71) {
          item.longContentBtn = true
          item.longContent = true
          item.miniContent = item.commentContent.substring(0, 71) + '...'
        } else {
          item.miniContent = item.commentContent
        }
        // 商家回复 storeCommentReplies
        if (item.storeCommentReplies && item.storeCommentReplies.length) {
          const replies = item.storeCommentReplies
          replies.forEach(reply => {
            if (reply.replyContent.length > 71) {
              reply.longBtn = true
              reply.long = true
              reply.miniReply = reply.replyContent.substring(0, 71) + '...'
            } else {
              reply.miniReply = reply.replyContent
            }
          })
        }
        // 用户追评 experienceContent
        if (item.experienceContent && item.experienceContent.length) {
          const edata = item.experienceContent
          if (edata.length > 71) {
            item.longExperienceBtn = true
            item.longExperience = true
            item.miniExperienceContent = item.experienceContent.substring(0, 71) + '...'
          } else {
            item.longExperience = false
            item.miniExperienceContent = item.experienceContent
          }
        }
        // 客服回复 serviceCommentReplies
        if (item.serviceCommentReplies && item.serviceCommentReplies.length) {
          const serviceCommentReplies = item.serviceCommentReplies
          serviceCommentReplies.forEach(serviceCommentReply => {
            if (serviceCommentReply.replyContent.length > 71) {
              serviceCommentReply.longServiceBtn = true
              serviceCommentReply.longService = true
              serviceCommentReply.miniServiceContent = serviceCommentReply.replyContent.substring(0, 71) + '...'
            } else {
              serviceCommentReply.longService = false
              serviceCommentReply.miniServiceContent = serviceCommentReply.replyContent
            }
          })
        }
      })
      return commentList
    },
    /**
     * @description 跳转门店
     */
    fnGoToStore(activityFlag) {
      if (this.$util.isShopKeeper()) {
        this.$util.gioTrackWithVariable('YG20184', {
          product_id: this.gioObject?.productId,
          product_name: this.gioObject?.productName,
          store_id: this.gioObject?.storeId,
          md_code: this.storeInfo?.mdCode,
        }, true)
      }
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20268', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }
      this.$router.push({
        path: '/shopDetail',
        query: {
          storeId: this.storeInfo.o2oStoreId,
          mdCode: this.storeInfo?.mdCode || ''
        },
      })

      this.gioHZ20017()
    },
    /**
     * @description 跳转到直播页面
     */
    gotoLive() {
      this.$store.dispatch('doHistoryBack', true)
    },
    /**
     * 获取问答区域数据
     */
    getMaxAnswerProductQuestion(params) {
      // params.sku = 'quest2'
      getMaxAnswerProductQuestion({ sku: params.sku }).then(res => {
        // console.log(res, 'getMaxAnswerProductQuestion')
        let { result, pager, success } = res
        if (success && result && pager) {
          let productInfo = {
            productId: params.productId,
            sku: params.sku,
            pager,
            productFullName: params.productFullName,
            defaultImageUrl: params.defaultImageUrl,
            rowsCount: pager.rowsCount,
          }
          this.answerAreaInfo = {
            ...productInfo,
            result,
          }
          // this.setAnswerAreaInfo(productInfo);
        }
      }).catch(e => console.log(e))
    },
    /**
     * @description 评论展开收起
     */
    fnShowCommentContent(data) {
      if (data.type === 'commentContent') {
        // 评论
        this.commentList[data.index].longContent = !this.commentList[data.index].longContent
      } else if (data.type === 'experienceContent') {
        // 追评
        this.commentList[data.index].longExperience = !this.commentList[data.index].longExperience
      } else if (data.type === 'serviceReplyContent') {
        // 客服回复
        this.commentList[data.index].serviceCommentReplies[data.subIndex].longService = !this.commentList[data.index].serviceCommentReplies[data.subIndex].longService
      } else if (data.type === 'replyContent') {
        // 商家回复
        this.commentList[data.index].storeCommentReplies[data.subIndex].long = !this.commentList[data.index].storeCommentReplies[data.subIndex].long
      }
    },
    /**
     * @description 切换地址
     */
    handleLocation() {
      if (this.$route.query.exclusiveId) this.queryExclusivePrice(this.$route.query.exclusiveId)

      if (this.$refs.swiper) {
        this.$refs.swiper?.player?.dispose?.()
        this.$refs.swiper.player = null
        this.$refs.swiper.smallVideoShow = false
      }
      // 切换地址需要重新获取商品动态信息
      this.dynamic()
    },
    /**
     * @description 加减商品数量
     */
    fnChangeProductNumber(number) {
      this.productNumber = number
      // if (this.sgAttribute && this.sgStoreAttribute) {
      //   if (this.$route.query.exclusiveId) this.queryExclusivePrice(this.$route.query.exclusiveId)
      //   this.dynamic()
      // }
    },
    /**
     * @description 多规格切换规格时重置购买数量(不刷新)
     */
    changeGoodsNumber(number) {
      this.productNumber = number
    },
    /**
     * @description 打开多规格弹窗
     */
    openAttr(value) {
      // 不可销售时禁用购买
      if (this.notSaleStatus) return
      this.chooseGroupId = 0 // 点击其他按钮时重置参团Id
      this.openFrom = 2
      this.lastSelectRealBtn = value
      this.btnType = value
      if (value === 0) {
        // MB13413 - 点击加入购物车
        this.$util.gioTrackWithVariable('MB13413', {
          productId_var: this.productId + '',
        })
        if (this.$util.isShopKeeper()) {
          this.$util.gioTrackWithVariable('YG20142', {
            product_id: this.gioObject?.productId,
            product_name: this.gioObject?.productName,
            store_id: this.gioObject?.storeId,
            md_code: this.storeInfo?.mdCode,
          }, true)
        }
        if (this.$util.isSyBird()) {
          this.$util.gioTrackWithVariable('BD20267', {
            product_id: this.productId,
            product_name: this.products?.productFullName,
            md_code: this.storeInfo?.mdCode,
            store_id: this.o2oStoreId,
            origin: this.$route.query?.trk_origin || this.trk_origin,
          })
        }
        this.gioIH35363738('IH20037')
      }
      if (value === 1) {
        if (this.$util.isShopKeeper()) {
          this.$util.gioTrackWithVariable('YG20143', {
            product_id: this.gioObject?.productId,
            product_name: this.gioObject?.productName,
            store_id: this.gioObject?.storeId,
            md_code: this.storeInfo?.mdCode,
          }, true)
        }
        if (this.$util.isSyBird()) {
          this.$util.gioTrackWithVariable('BD20266', {
            product_id: this.productId,
            product_name: this.products?.productFullName,
            md_code: this.storeInfo?.mdCode,
            store_id: this.o2oStoreId,
            origin: this.$route.query?.trk_origin || this.trk_origin,
          })
        }
        this.gioIH35363738('IH20038')
      }
      if(this.skku){
        if(value){
          this.fnGoBuy(value)
        }else{
          this.fnAddCart()
        }
      }else if(this.hasSubProduct || this.$util.isInternalChannel() || this.$util.isShopKeeper() || ![1,3].includes(value) || [70].includes(this.activityInfo?.activityType)){
        this.$refs.goodsInfo && this.$refs.goodsInfo.fnShowInfo()
      }else{
        this.fnGoBuy(1)
        // switch (value) {
        //   case 1:
        //   case 9:
        //   case 4:
        //     // 立即购买
        //     this.fnGoBuy(1)
        //     break;
        //   case 3:
        //     // 马上预定
        //     this.bookableBuy()
        //     break;
        //   case 5:
        //   case 10:
        //     // 定金支付、拼团
        //     this.fnGoBuy(0)
        //     break;
        // }
      }
    },
    // fromChoosen为代表点击已选按钮 触发该函数
    openAttrFromToggle(value, fromChoosen = false) {
      // 不可销售时禁用购买
      // if (this.notSaleStatus) return
      if (this.chooseGroupId) {
        this.openFrom = 2
      } else {
        this.openFrom = 1
      }
      this.$refs.goodsInfo && this.$refs.goodsInfo.fnShowInfo()
      this.btnType = value
      if (value === 0) {
        // MB13413 - 点击加入购物车
        this.$util.gioTrackWithVariable('MB13413', {
          productId_var: this.productId + '',
        })
        if (this.$util.isShopKeeper()) {
          this.$util.gioTrackWithVariable('YG20142', {
            product_id: this.gioObject?.productId,
            product_name: this.gioObject?.productName,
            store_id: this.gioObject?.storeId,
            md_code: this.storeInfo?.mdCode,
          }, true)
        }
        if (this.$util.isSyBird()) {
          this.$util.gioTrackWithVariable('BD20267', {
            product_id: this.productId,
            product_name: this.products?.productFullName,
            md_code: this.storeInfo?.mdCode,
            store_id: this.o2oStoreId,
            origin: this.$route.query?.trk_origin || this.trk_origin,
          })
        }
        this.gioIH35363738('IH20037')
      }
      if (value === 1) {
        if (this.$util.isShopKeeper()) {
          this.$util.gioTrackWithVariable('YG20143', {
            product_id: this.gioObject?.productId,
            product_name: this.gioObject?.productName,
            store_id: this.gioObject?.storeId,
            md_code: this.storeInfo?.mdCode,
          }, true)
        }
        if (this.$util.isSyBird() && !fromChoosen) {
          this.$util.gioTrackWithVariable('BD20266', {
            product_id: this.productId,
            product_name: this.products?.productFullName,
            md_code: this.storeInfo?.mdCode,
            store_id: this.o2oStoreId,
            origin: this.$route.query?.trk_origin || this.trk_origin,
          })
        }
        this.gioIH35363738('IH20038')
      }
    },
    /**
     * @description 加入购物车
     */
    fnAddCart(otype) {
      if (this.islogining) return
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20290', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }
      if (!this.verifyTagCheckStatus()) {
        if (!this.$refs.goodsInfo.showInfoFlag) {
          this.$refs.goodsInfo.showInfoFlag = true
          return
        } else {
          return this.$toast('规格选择不完整')
        }
      }
      if (this.$refs.goodsInfo.showInfoFlag) this.$refs.goodsInfo.showInfoFlag = false
      if (this.$refs.goodsInfo.showSpuFlag) this.$refs.goodsInfo.showSpuFlag = false

      // 判断登陆
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.gioBD20114()
        this.gioHZ20017()
        this.enterTime = Date.now()
        this.$store
          .dispatch('doLogin')
          .then(res => {
            if (res !== 400) {
              this.islogining = false
              this.reload()
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        return
      }
      if (!this.baseInfo.supportCart || this.hideCartBtn) {
        // 不允许加入购物车
        this.$toast('此商品暂时不能加入购物车')
        return
      }
      // await this.checkStockForNum(otype) // 校验库存
      const { comId, caseId, directSaleType } = this.$route.query
      let _goodsInfo = {
        attrValueNames: this.hasSubProduct ? this.attrValueNames || null : null, // 只有含子商品多规格才传规格名称
        number: this.productNumber || 1,
        productId: this.productId,
        skku: this.hasSubProduct ? this.skku || null : null, // 只有含子商品多规格才传skku
        sku: this.products.sku,
        visitStore: this.visitStore || '',
        comId,
        caseId,
        directSaleType,
        undertakeStore: this.storeInfo ? this.storeInfo.o2oStoreId : '',
        shareId: this.getShareId ? this.getShareId : '',
        exclusiveId: this.$route.query.exclusiveId,
        externalSource: this.sourceTypeAndCode.sourceType === 'GYYXMF' ? 2 : '',
      }
      this.visitStoreHandler(_goodsInfo)
      this.$util.gioTrackWithVariable('MB10801', {
        productId_var: this.productId + '',
        md_code: this.storeInfo?.mdCode || 'null',
        store_code: this.o2oStoreId? this.o2oStoreId + '' : 'null',
        product_name: this.products?.productFullName || 'null',

      })
      if (this.$util.isHaierApp()) {
        // 智家创建订单成功 vdn 埋点
        this.$util
          .uplusReportPageClickEvent({
            actionCode: '1002',
            extentInfo: { user_id: this.ucId, member_id: this.mId, productId_var: this.productId },
          })
          .then(() => {
            console.log('加入购物车的商品信息：', _goodsInfo)
            // 智家App加入购物车埋点
            this.$util.gioTrackWithVariable('add_to_cart', {
              member_id: this.mId ? this.mId + '' : 'null',
              productId_var: this.productId ? this.productId + '' : 'null',
              user_id: this.ucId ? this.ucId + '' : 'null',
            })
            this.addCart(_goodsInfo)
          }).catch(e => { console.log(e) });
      } else {
        gio('track', 'add_to_cart', {
          user_id: this.ucId,
          member_id: this.mId,
          productId_var: this.productId,
        })
        console.log('加入购物车的商品信息：', _goodsInfo)
        this.addCart(_goodsInfo)
      }
    },
    // 修复商品既是无货可预订，又有拼团活动的情况，点击“去参团”时 无法使用拼团价
    bookableBuy() {
      if (this?.activityInfo?.activityType === 75) {
        this.fnGoBuy('0', '5')
      } else {
        this.fnGoBuy('1', '5')
      }
    },
    /**
     * @description 立即购买
     */
    async fnGoBuy(ac, otype) {
      if (this.islogining) return

      this.gioHZ20017()
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20289', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }

      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.gioBD20114()
        this.enterTime = Date.now()
        this.$store
          .dispatch('doLogin')
          .then(res => {
            if (res !== 400) {
              this.islogining = false
              this.reload()
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        const t = setTimeout(() => {
          clearTimeout(t)
          this.islogining = false
        }, 1000)
        return
      }
      this.$util.gioTrackWithVariable('MB13415', {
        user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
        member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
        productId_var: this.productId + '',
      })
      if(this.discountActivityInfo?.discountRecommend) {
        this.goDiscountPage()
      }else {
        this.debouncedBuyAction(ac, otype)
      }
    },
    async doBuyAction(ac, otype) {
      if (this.islogining) return
      if (!this.verifyTagCheckStatus()) {
        if (!this.$refs.goodsInfo.showInfoFlag) {
          this.$refs.goodsInfo.showInfoFlag = true
          return
        } else {
          return this.$toast('规格选择不完整')
        }
      }
      // 立即购买埋点
      gio('track', 'BuyNow', {
        storeId: this.o2oStoreId,
        productName: this.shopInfo.data.products.productName,
        productId: this.shopInfo.data.products.productId + '',
        productEncode: this.shopInfo.data.products.sku,
      })
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.$store
          .dispatch('doLogin')
          .then(res => {
            if (res !== 400) {
              this.islogining = false
              this.reload()
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        return
      }
      // console.log(this.productNumber)
      // if (this.productNumber === 0) {
      //   return
      // }
      // await this.checkStockForNum(otype) // 校验库存
      const { query: _q } = this.$route
      const pro = {
        name: this.hasSubProduct ? this.attrValueNames || null : null, // 只有含子商品多规格才传规格名称
        sku: this.hasSubProduct ? this.skku || null : null, // 只有含子商品多规格才传skku
        proId: this.productId,
        num: this.productNumber || 1,
        visitStore: this.visitStore,
        exclusivePriceId: _q.exclusiveId || '',
        caseId: _q.caseId || '',
      }
      if (_q.fkcode || _q.sceneVersion) {
        pro.sceneParam = {}
        if (_q.fkcode) {
          pro.sceneParam.fkcode = _q.fkcode
        }
        if (_q.sceneVersion) {
          pro.sceneParam.sceneVersion = _q.sceneVersion
        }
        if (_q.sceneType) {
          pro.sceneParam.sceneType = _q.sceneType
        }
      }
      if (_q.sendOrderType) {
        pro.sendOrderType = _q.sendOrderType
      }
      // directCode
      if(_q.directCode){
        pro.directCode = _q.directCode
      }
      // 滤芯设备码
      if (_q.deviceCode) {
        pro.relationCode = _q.deviceCode
      }
      this.visitStoreHandler(pro)
      let _proList = [pro]
      this.setExclusiveStatus(this.isExclusive)

      let coupon = []

      this.voucherList.length &&
        this.voucherList.forEach(item => {
          if (item.marking === 'sheng' && item.displayType === '1') {
            coupon.push({
              activityCode: item.activityCode,
              couponTemplateCode: item.couponTemplateCode,
              couponCode: item.couponCode,
              couponTemplateName: item.couponTemplateName,
            })
          }
        })
      let query = {
        _proList: _proList,
        ac: ac,
        isExclusive: this.isExclusive,
        originSource: this.originSource,
        groupId: this.chooseGroupId || 0, // 拼团Id ac为0 groupId为0代表是团长
        // coupon: coupon
        comId: _q.comId,
        pageSource: ORDERFORMENUM.GOOD_DETAIL, // 创建订单的来源页面
        mdCode: this.storeInfo?.mdCode,
        tradeInId: _q?.tradeInId || '', //以旧换新 tradeInId
      }
      if (_q.drainageCode) {
        query.sceneCode = _q.drainageCode
      }
      if (this.baseInfo.showCoupons) {
        query.coupon = coupon
      }
      // 来源类型 滤芯-filter
      if (_q.otherSourceType) {
        query.originSource = _q.otherSourceType
      }
      if(this.payNum){
        query.payNum = this.payNum
      }
      // dsg43784 分享下单时记录身份 把url中的shareRole传给createOrder接口
      if(_q.shareRole){
        query.shareRole = _q.shareRole
      }
      this.$router.push({
        name: 'create',
        query,
      })
    },
    /**
     * @description 加购物车、购买检查库存
     */
    checkStockForNum(otype) {
      let _param = this.getCheckStockParams() // 获取校验库存参数
      return new Promise((resolve, reject) => {
        checkStockForNum(_param).then(res => {
          if (res.success) {
            if ((!res.data || !res.data.hasStock) && otype !== '5') {
              // otype为5时是 马上预定
              this.$toast('库存不足')
            } else {
              resolve()
            }
          } else {
            this.$toast(res.message)
          }
        }).catch(e => { console.log(e) });
      })
    },
    getCheckStockParams: function() {
      const stockType = this.sgStockInfo.stockType
      const skku = this.skku
      const prodId = this.productId
      const regionId = this.location.districtId
      const o2oStoreId = this.storeInfo ? this.storeInfo.o2oStoreId : null
      const storeCode = this.storeInfo ? this.storeInfo.storeCode : null
      const streetId = this.location.townshipId
      const memberId = this.$store.getters.mId
      const number = this.productNumber
      let params
      if (stockType === 'WA') {
        params = {
          stockType: stockType,
          productId: prodId,
          number: number,
          memberId: memberId,
          streetId: streetId,
          regionId: regionId,
        }
      } else if (stockType === 'O2O') {
        params = {
          stockType: stockType,
          productId: prodId,
          number: number,
          memberId: memberId,
          streetId: streetId,
          o2oStoreId: o2oStoreId,
          storeCode: storeCode,
        }
      } else {
        params = {
          stockType: stockType,
          productId: prodId,
          number: number,
          memberId: memberId,
          streetId: streetId,
        }
      }
      if (skku) {
        params.sku = skku
      } else {
        params.sku = null
      }
      return params
    },
    /**
     * @description 显示输入手机号通知页面
     * localStorage.getItem('notifycationMobile')，获取暂存本地的手机号
     */
    fnArrivalNotice() {
      // 不可销售时禁用购买
      if (this.notSaleStatus || this.$util.isInternalChannel()) return
      this.dialogShow = !this.dialogShow
      this.mobile = localStorage.getItem('notifycationMobile') || ''
      if (this.dialogShow) {
        this.$util.gioTrackWithVariable('MB13410', {
          user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
          member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
          productId_var: this.productId + '',
        })
      }
    },
    /**
     * @description 已选点击回调
     * groupId： 拼团参团Id
     */
    toggleShowInfo(groupId) {
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20272', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }
      this.chooseGroupId = groupId
      if (!(this.activityInfo && this.activityInfo.activityType === 81)) {
        console.log(this.activityInfo)
        if (this.sgStockInfo && !this.sgStockInfo.hasStock) {
          // 无库存
          if (this.activityInfo && this.activityInfo.activityType === 100 && this.sgStockInfo.bookable) {
            if (this.activityInfo.deposit !== 1) {
              this.openAttrFromToggle(5)
            } else {
              this.openAttrFromToggle(7)
            }
          } else if (this.sgStockInfo.bookable || this.parentBookable) {
            // 预定商品
            this.openAttrFromToggle(3)
          } else if (!this.sgStockInfo.bookable) {
            if (!this.notSaleStatus) {
              // 到货通知
              this.openAttrFromToggle(2)
            } else {
              // 有库存
              if (this.activityInfo && this.activityInfo.activityType === 100) {
                if (this.activityInfo.deposit !== 1) {
                  this.openAttrFromToggle(5)
                } else {
                  this.openAttrFromToggle(7)
                }
              } else {
                // 立即购买
                // if (this.baseInfo.supportCart) {
                this.openAttrFromToggle(6)
                // } else {
                // this.openAttrFromToggle(1)
                // }
              }
            }
          }
        } else {
          // 有库存
          if (this.activityInfo && this.activityInfo.activityType === 100) {
            if (this.activityInfo.deposit !== 1) {
              this.openAttrFromToggle(5)
            } else {
              this.openAttrFromToggle(7)
            }
          } else if (this.activityInfo && this.activityInfo.activityType === 75) {
            // 店铺拼团
            if (groupId) {
              this.openFrom = 2
              this.openAttrFromToggle(10)
            } else {
              this.openAttrFromToggle(11)
            }
          } else {
            // 立即购买
            if (this.baseInfo.supportCart && !this.hideCartBtn) {
              this.openAttrFromToggle(6)
            } else {
              this.openAttrFromToggle(1, true)
            }
          }
        }
      } else {
        this.openAttrFromToggle(8)
      }
    },
    /**
     * @description 多规格内切换规格时刷新底部按钮
     */
    refreshBtnType() {
      if (!(this.activityInfo && this.activityInfo.activityType === 81)) {
        if (this.sgStockInfo && !this.sgStockInfo.hasStock) {
          // 无库存
          if (this.activityInfo && this.activityInfo.activityType === 100 && this.sgStockInfo.bookable) {
            if (this.activityInfo.deposit !== 1) {
              this.btnType = 5
            } else {
              this.btnType = 7
            }
          } else if (this.sgStockInfo.bookable || this.parentBookable) {
            // 预定商品
            this.btnType = 3
          } else if (!this.sgStockInfo.bookable) {
            if (!this.notSaleStatus) {
              // 到货通知
              this.btnType = 2
            } else {
              // 有库存
              if (this.activityInfo && this.activityInfo.activityType === 100) {
                if (this.activityInfo.deposit !== 1) {
                  this.btnType = 5
                } else {
                  this.btnType = 7
                }
              } else {
                // 立即购买
                // if (this.baseInfo.supportCart) {
                this.btnType = 6
                // debugger
                // } else {
                //   this.btnType = 1
                // }
              }
            }
          }
        } else {
          // 有库存
          if (this.activityInfo && this.activityInfo.activityType === 100) {
            if (this.activityInfo.deposit !== 1) {
              this.btnType = 5
            } else {
              this.btnType = 7
            }
          } else if (this.activityInfo && this.activityInfo.activityType === 75) {
            // 拼团
            if (this.openFrom === 1) {
              this.btnType = 11
            } else {
              if (this.lastSelectRealBtn === 9) {
                this.btnType = 9
              } else {
                this.btnType = 10
              }
            }
          } else {
            // 立即购买
            if (this.baseInfo.supportCart && !this.hideCartBtn) {
              this.btnType = 6
            } else {
              this.btnType = 1
            }
          }
        }
      } else {
        this.btnType = 8
      }
    },
    async fnNotice() {
      // 校验手机号
      if (!/^1([3456789][0-9]|4[01356789]|66|9[89])\d{8}$/.test(this.mobile)) {
        this.$toast('手机号格式不正确')
        return
      }
      // 通过手机格式校验后，暂存手机号到本地缓存
      localStorage.setItem('notifycationMobile', this.mobile)
      await this.checkOnly()
      this.insertNotice()
    },
    /**
     * @description 检验到货通知是否发送
     */
    checkOnly() {
      return new Promise((resolve, reject) => {
        checkOnly({
          productId: this.productId, // 商品ID
          mobile: this.mobile,
          provinceId: this.location.provinceId,
          cityId: this.location.cityId,
          areaId: this.location.districtId,
          streetId: this.location.townshipId,
        }).then(res => {
          if (res.success) {
            if (res.result === 0) {
              resolve()
            } else {
              this.$toast('该手机号在该地区已经申请到货通知，不能重复申请！')
            }
          } else {
            this.$toast(res.message)
          }
        }).catch(e => console.log(e))
      })
    },
    /**
     * @description 添加到货通知
     */
    insertNotice() {
      insertNotice({
        productId: this.productId, // 商品ID
        mobile: this.mobile,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        areaId: this.location.districtId,
        streetId: this.location.townshipId,
        sku: this.skku ? this.skku : this.products.sku,
        productName: this.products.productName,
        provinceName: this.location.province,
        cityName: this.location.city,
        areaName: this.location.district,
        o2oStoreId: this.storeInfo ? this.storeInfo.o2oStoreId : null,
      }).then(res => {
        if (res.success) {
          this.$util.gioTrackWithVariable('MB13411', {
            user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
            member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
            productId_var: this.productId + '',
          })
          this.$toast('您的资料已经提交，到货后我们会第一时间通知您！')
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    fnOpenCustomerService() {
      if (this.islogining) return

      this.gioHZ20017()
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20269', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }
      this.gioIH35363738('IH20035')

      let isShowLive = this.$route.query.show_live
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.gioBD20114()
        this.enterTime = Date.now()
        this.$store
          .dispatch('doLogin')
          .then(res => {
            if (res !== 400) {
              this.islogining = false
              if (+isShowLive) {
                instance.initDeviceReady().then(() => {
                  instance.upLiveModule
                    .closeFloatWindow()
                    .then(result => {
                      this.toCustomerService()
                    })
                    .catch(() => {
                      this.toCustomerService()
                    })
                }).catch(e => { console.log(e) });
              } else {
                this.toCustomerService()
              }
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        return
      }
      if (+isShowLive) {
        instance.initDeviceReady().then(() => {
          instance.upLiveModule
            .closeFloatWindow()
            .then(result => {
              this.toCustomerService()
            })
            .catch(() => {
              this.toCustomerService()
            })
        }).catch(e => { console.log(e) });
      } else {
        this.toCustomerService()
      }
    },
    getCustomerInfo() {
      return new Promise((resolve, reject) => {
        getCustomer({
          storeCode:this.storeInfo && this.storeInfo.storeCode ? this.storeInfo.storeCode : ''
        }).then( async res => {
          if (res.data.result) {
            this._accountId = this.storeInfo && this.storeInfo.storeCode ? this.storeInfo.storeCode : ''
          } else {
            this._accountId = undefined
          }
        })
      })
    },
    getCardId() {
      const context = this
      return new Promise((resolve, reject) => { 
        let displayPrice = +(context.priceInfo?.priceType === 100 ? context.priceInfo?.finalPrice: context.priceInfo?.actualPrice)
        postServiceCenter({
          productName: this.products?.productFullName,
          productPicture: this.swiperImgs[0]?.baseImage || context.swiperImgs[0]?.img || (typeof context.swiperImgs[0] === 'string' ? context.swiperImgs[0] : 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/img_bg.png'),
          productInfoUrl: this.productUrl,
          productPrice: displayPrice + '',
        }).then(res => {
          if (res.success && res.data) {
            this._cardId = res?.data?.cardId
          }
        }).catch(e => { console.log(e) });
      })
    },
    /**
     * @description 单品页回传商品信息给客服中心
     */
    postServiceCenter() {
      const context = this
      if (context._cardId) {
        this.$store.dispatch('goPageByType', {
          type: 29,
          params: {
            accountId: this._accountId,
            sceneId: 'cj091',
            cardId: context._cardId
          },
        })
        this.islogining = false
      } else {
        this.$store.dispatch('goPageByType', {
          type: 29,
          params: {
            accountId: this._accountId,
            sceneId: 'cj091',
          },
        })
        this.islogining = false
      }
    },
    async toCustomerService() {
      this.$util.gioTrackWithVariable('MB13412', {
        user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
        member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
        productId_var: this.productId + '',
      })
      if (this.$util.isShopKeeper()) {
        this.$util.gioTrackWithVariable('YG20140', {
          product_id: this.gioObject?.productId,
          product_name: this.gioObject?.productName,
          store_id: this.gioObject?.storeId,
          md_code: this.storeInfo?.mdCode,
        }, true)
      }
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20269', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }
      if (!this.$store.getters.getLoginStatus) {
        this.$store.dispatch('doLogin')
        this.islogining = false
        return
      }
      this.postServiceCenter()
    },
    /**
     * @description 验证传入的88码是否开通商家客服
     */
    isCanGetCustomer(storeCode) {
      return new Promise((resolve, reject) => {
        const data = {
          storeCode: storeCode,
        }
        personalApi.getCustomer(data).then(res => {
          if (res.data.success) {
            resolve(res.data.result)
          }
        }).catch(e => { console.log(e) });
      })
    },
    fnOpenCart() {
      if (this.islogining) return

      this.gioHZ20017()
      if (this.$util.isSyBird()) {
        this.$util.gioTrackWithVariable('BD20270', {
          product_id: this.productId,
          product_name: this.products?.productFullName,
          md_code: this.storeInfo?.mdCode,
          store_id: this.o2oStoreId,
          origin: this.$route.query?.trk_origin || this.trk_origin,
        })
      }
      this.gioIH35363738('IH20036')

      this.$util.gioTrackWithVariable('MB15626')
      // 未登录 处理
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.gioBD20114()
        this.enterTime = Date.now()
        this.$store
          .dispatch('doLogin')
          .then(res => {
            if (res !== 400) {
              this.islogining = false
              this.reload()
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        return
      }
      if (this.$util.isShopKeeper()) {
        this.$util.gioTrackWithVariable('YG20141', {
          product_id: this.gioObject?.productId,
          product_name: this.gioObject?.productName,
          store_id: this.gioObject?.storeId,
          md_code: this.storeInfo?.mdCode,
        }, true)
      }
      let queryParam = {}
      if (this.originSource) {
        queryParam.originSource = this.originSource
      }
      this.$router.push({
        path: '/cart',
        query: queryParam,
      })
    },
    fnScrollTo(refName, event) {
      event.preventDefault()
      this.cancelScroll = true
      this.activeAnchor = refName
      this.showComment = true
      Promise.all([lazyGoodsDetail(), lazyCommentInfo(), lazyShopInfo()]).then(() => {
        this.$nextTick(() => {
          this.$refs[refName].scrollIntoView({
            block: 'start',
          })
        })
      }).catch(e => { console.log(e) });
      setTimeout(() => {
        this.cancelScroll = false
      }, 100)
    },
    fnBack() {
      this.gioBD20114()
      this.gioHZ20017()
      if (utils.isHaierApp()) {
        this.gioMB13407()
        this.enterTime = 0
      }
      this.enterTime = 0
      this.$store.dispatch('doHistoryBack')
    },
    /**
     * 管理员设置专属价
     */
    manageSetPrice() {
      this.showSetPrice = true
    },
    closeManageDialog() {
      this.showSetPrice = false
    },
    doSetPrice(price) {
      let params = {
        productId: this.productId,
        mdCode: this.storeInfo?.mdCode || '',
        price,
      }
      if (this.skku) params.skku = this.skku
      this.$http.post(URL.generateExclusivePrice, params, {
        cancelRepeat: true
      }).then(({ data }) => {
        console.log(data)
        let result = data
        if (result.success && result.data) {
          this.showSetPrice = false
          // location.replace(result.data) //返回有问题
          let url = result.data;
          // console.log(this.$util.parseQueryToJson(url.split('?')[1]))
          // this.$router.replace(`/goodsDetail?${url.split('?')[1]}`)
          this.$router.replace({
            path: '/goodsDetail',
            query: this.$util.parseQueryToJson(url.split('?')[1])
          })
          this.init()
        } else if (this.getUserIdentifyInfo?.storePartnerInfo?.storeGuide === 2) { // 导购身份
          this.$refs.managePriceDialog.tips = result.message
        } else {
          this.$toast(result.message)
        }
      }).catch(e => { console.log(e) });
    },
    /**
     * @description 单品详情页分享信息接口
     */
    productQrCode() {
      let _param = {}
      if (this.skku) {
        _param.sku = this.skku
      }
      if (this.storeId) {
        // 分享人id
        _param.storeId = this.storeId
      }
      productQrCode({
        productId: this.productId,
        channelId: 3, // 4微商城，不传或者3为M站APP
        spu: this.products.sku,
        streetId: this.location.townshipId,
        ..._param,
      }).then(res => {
        if (res.success) {
          // 超出2行 溢出隐藏
          if (res.data.productName && res.data.productName.length > 48) {
            res.data.productName = `${res.data.productName.slice(0, 48)}...`
          }

          this.shareGoodsInfo = {
            ...res.data,
          }
        }
      }).catch(e => { console.log(e) });
    },
    async fnReserve() {
      // 不可销售时禁用购买
      if (this.notSaleStatus) return
      if (this.islogining) return
      // 判断登陆
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.$store
          .dispatch('doLogin')
          .then(res => {
            if (res !== 400) {
              this.islogining = false
              this.reload()
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        return
      }
      await this.checkMemberReserve()
      this.reservationShowFlag = true
    },
    /**
     * @description 检查是否可以预约
     */
    checkMemberReserve() {
      return new Promise((resolve, reject) => {
        checkMemberReserve({
          acReserveId: this.activityInfo.activityId,
          productId: this.productId,
        }).then(res => {
          if (res.success) {
            if (res.data) {
              resolve()
            } else {
              this.$toast(res.message)
            }
          } else {
            this.$toast(res.message)
          }
        }).catch(e => console.log(e))
      })
    },
    /**
     * @description 预约抢购发送短信
     */
    sendSmsCaptcha(mobile) {
      sendSmsCaptcha({
        mobile,
      }).then(res => {
        if (res.success) {
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    /**
     * @description 确认预约
     */
    reserve(mobile, mobileCode) {
      reserve({
        acReserveId: this.activityInfo.activityId,
        productId: this.productId,
        mobile,
        mobileCode,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        districtId: this.location.districtId,
        streetId: this.location.townshipId,
      }).then(res => {
        if (res.success) {
          if (res.data) {
            this.$toast('商品预约成功，可在个人中心-我的预约中查看预约商品')
          } else {
            this.$toast(res.message)
          }
        } else {
          this.$toast(res.message)
        }
      }).catch(e => console.log(e))
    },
    fnChangeReservationShowFlag() {
      this.reservationShowFlag = !this.reservationShowFlag
    },
    commentBack() {
      this.commentHeader = false
    },
    toggleCommentHeader() {
      this.commentHeader = !this.commentHeader
    },
    /**
     * swiperChange
     */
    swiperChange(index, hasVideo) {
      this.curSwiper = index + 1
      if (hasVideo) {
        this.$util.trackWithVariable({
          platformConf: {
            [PlatformTypes.SYN_APP | PlatformTypes.SYN_H5]: {
              id: 'BD20193',
              param: ['md_code', 'store_id', 'product_id', 'product_name', 'fk_code', 'fc_code', 'scene_name', 'origin', 'site_number']
            }
          }
        }, {
          md_code: this?.storeInfo?.mdCode,
          store_id: this.gioObject?.storeId,
          product_id: this.gioObject?.productId,
          product_name: this.gioObject?.productName,
          fk_code: this.gioObject?.fkCode,
          fc_code: this.gioObject?.fcCode,
          scene_name: 'null',
          origin: this.gioObject?.trkOrigin,
          site_number: this.curSwiper,
        }).then((res) => {
          console.log('BD20193', res);
        })
      }
    },
    /**
     * sceenChange
     */
    sceenChange(flag) {
      this.isAllSceenSwiper = flag
    },
    /**
     * @description 重置按钮类型
     */
    resetBtnType() {
      // this.btnType = -1
    },
    setStorageToShare() {
      // isSyBirdStore: this.storeInfo && Number(this.storeInfo.synStoreType) !== 9,
      const params = {
        mdCode: this?.storeInfo?.mdCode || '',
        storeId: this.o2oStoreId || '',
        actualPrice: this.priceInfo.actualPrice,
        spuList: this.spuInfo
          ? this.spuInfo.spuSpecsList[0].spuSkuList.map(spu => {
            return { productId: spu.productId, skuShortName: spu.skuShortName }
          })
          : [],
      }
      const mainIndex = params.spuList.findIndex(item => {
        return item.productId === Number(this.productId)
      })
      if (mainIndex === -1) {
        params.spuList.unshift({
          productId: Number(this.productId),
          productFullName: this.products.productFullName,
        })
      } else {
        const item = params.spuList.splice(mainIndex, 1)[0]
        item.productFullName = this.products.productFullName
        params.spuList.unshift(item)
      }
      if (this.$util.isShopKeeper()) {
        params.shareId = this.mId
      }
      const jsonStr = JSON.stringify(params)
      localStorage.setItem('shareMessage', jsonStr)
    },

    async getGuiderList() {
      // todo  getListFlag  判断分享人身份 0：代表分享人是导购但未开通聊天功能 2:代表分享人是已开通聊天功能的导购 1: 其他情况
      let getListFlag = 1
      if (this.getShareId && this.$util.isShopKeeperShared()) {
        const { data } = await getGuideProfile({
          memberId: this.getShareId
        })
        
        if (data?.data?.mdCode === this.storeInfo.mdCode) {
          if (data.data.userType === 1) {
            getListFlag = 2
          } else if (data.data.userType === 2) {
            getListFlag = 0
          }
        }
      }


      if (getListFlag) {
        getGoodsGuide({
          mdCode: this.storeInfo.mdCode,
          shareId: getListFlag === 2 ? this.getShareId : '',
        }).then(({ data }) => {
          if (data.success) {
            this.guiderList = data.data
          }
        }).catch(e => console.log(e))
      }
    },
    /**
     * 获取plus会员开通入口相关数据
     */
    getPlusEntrance() {
      // 场景码/场景fc码/场景引流码
      const sceneCode = 
      this.$route.query.fkcode 
        ? this.$route.query.fkcode 
        : this.$route.query.sceneCode 
          ? this.$route.query.sceneCode
          : this.$route.query.drainageCode
            ? this.$route.query.drainageCode
            : undefined
      const params = {
        storeId: this.storeInfo?.o2oStoreId || null,
        sku: this.skku || this.products.sku || '',
        price: this.priceInfo ? (this.priceInfo.priceType === 100 ? this.priceInfo.finalPrice : this.priceInfo.actualPrice) : null, // 价格，动态信息接口priceType=100取finalPrice，其他情况取actualPrice
        plusPrice: this.priceInfo?.plusPrice || null,
        sceneCode,
      }
      entrance(params).then(res => {
        if(res?.success && res?.data) {
          this.plusInfo.showPlusEntrance = res?.data?.showPlusEntrance ?? false
          this.plusInfo.additionalSave = res?.data?.additionalSave	 ?? ''
        }
      }).catch(err => {

      })
    },
    /**
     * 分享带visitStore参数与否的逻辑：
     * 1. 从搜索页（/goodsSearch）搜索商品跳转过来的时候，
     *    不管从M站哪里（比如店铺首页的搜索、M站首页的搜索、移动工作台对应身份的首页的搜索）进入到的搜索页，
     *    只要进入到搜索页带有visitStore，则把visitStore传到当前单品页
     *
     * 2. dsg38772私域逻辑迭代，由于移动工作台中有一个交互台首页，
     *    首页上会有搜索，点击打开容器跳转M站的搜索页，此时没有给M站传递visitStore，
     *    但是某些身份下需要这个参数，此时上面1的逻辑不生效。由于工作台已经上线，所以M站在此处做统一处理，补充逻辑如下：
     *    ----判断是否是移动工作台环境
     *        ----如果否，走公域逻辑，判断URL中是否带visitStore
     *                ----如果是，取dynamic接口中的storeInfo.o2oStoreId作为visitStore
     *                ----如果否，不做处理
     *        ----如果是，走私域逻辑，判断URL中是否带visitStore
     *                ----如果是，不做处理
     *                ----如果否，取dynamic接口中的storeInfo.o2oStoreId作为visitStore
     * 
     * 
     * 
     *  2022.09.27 会议更改逻辑
     * 1.公域端 单品页链接上如果有 visitStore，
     * 那么 单品页的分享，加购，收藏，进结算
     * 都要传 visitStore mdCode，从动态接口获取
     * 若没有则不传
     * 2.私域端进单品页需要传 visitStore mdCode，单品页的分享，加购，收藏，进结算也都要传，从动态接口获取
     * 
     * 分享，加购，收藏，进结算这几类，具体哪几个接口加 请全局搜索一下该函数名
     */
    visitStoreHandler(query) {
      if (this.$route.query.visitStore) {
        query.visitStore = this.o2oStoreId || ''
      }
      if (this.$route.query.mdCode) {
        query.mdCode = this?.storeInfo?.mdCode || ''
        //公域店铺入口锁店情况锁店
        localStorage.setItem('sg_yjhx_mdcoe', query.mdCode)
      }else{
        localStorage.setItem('sg_yjhx_mdcoe', '')
      }

      if (this.$util.isShopKeeper() && !this.$route.query.visitStore && !this.$route.query.mdCode) {
        if (this.mdCode) {
          query.mdCode = this.mdCode
        }
        if (this.visitStore) {
          query.visitStore = this.visitStore
        }
      }
      // // 私域（指移动工作台）分享、收藏、加购、进结算页携带visitStore mdCode逻辑
      // if (this.$util.isShopKeeper()) {
      //   console.log('visitStoreHandler', !this.$route.query.visitStore, this.o2oStoreId)
      //   query.visitStore = this.o2oStoreId
      //   if (this?.storeInfo?.mdCode) {
      //     query.mdCode = this.storeInfo.mdCode
      //   }
      // }
      // // 公域（除了移动工作台之外）分享、收藏、加购、进结算页携带visitStore mdCode逻辑
      // if (!this.$util.isShopKeeper() && this.$route.query.visitStore) {
      //   query.visitStore = this.o2oStoreId
      //   if (this?.storeInfo?.mdCode) {
      //     query.mdCode = this.storeInfo.mdCode
      //   }
      // }
    },
    /**
     * 凑单折扣及满减折扣信息
     */
    setDiscountActivityInfo(discountActivityInfo) {
      if(discountActivityInfo?.discountCondition?.length && discountActivityInfo?.startTime <= Date.now() <= discountActivityInfo.endTime) {
        this.discountActivityInfo = discountActivityInfo
        this.discountActivityInfo.discountList = this.$util.strJSONParse(discountActivityInfo?.discountCondition, [])
        this.discountActivityInfo.discountList?.sort((itema, itemb) => {
          return itema.sort - itemb.sort
        })
        this.discountActivityText = ''
        this.discountActivityInfo.discountList?.forEach((item, index) => {
          if(discountActivityInfo.discountType == 1){
            this.discountActivityText += `买${item.enableDiscountNum}件享${item.discount}折，`
          }else {
            this.discountActivityText += `满${item.enableDiscountPrice}减${item.discount}，`
          }
        })
        if(this.discountActivityText.length){
          this.discountActivityText = this.discountActivityText.substring(0, this.discountActivityText.length - 1)
        }
      }else {
        this.discountActivityInfo = {}
        this.discountActivityText = ''
      }
    },
    /**
     * 跳转店铺详情页
     */
    goShopDetail() {
      if(this.discountActivityInfo.storeId){ //店铺活动
        this.$router.push({
          path: '/shopDetail',
          query: {
            storeId: this.storeInfo.o2oStoreId,
            mdCode: this.storeInfo?.mdCode || '',
            activityName: '活动',
          },
        })
      }else{ // 平台活动
        this.$router.push({
          path: '/fullDiscount',
          query: {
            activityId: this.discountActivityInfo.activityId,
            mdCode: this.$route.query.mdCode || '',
            storeId: this.$route.query.visitStore || '',
          },
        })
      }
      
    },

    goDiscountPage() {
      let query = {
        parentId: this.discountActivityInfo?.parentActivityId || '',
        activityId: this.discountActivityInfo?.activityId || '',
        sku: this.products.sku,
        skku: this.skku || null,
        buyNums: this.productNumber,
      }

      query.visitStore = this.$route.query.visitStore || ''
      query.mdCode = this.$route.query.mdCode  || '',

      this.$router.push({
        path: '/collectDiscount',
        query,
      })
    },
  },
}
</script>
<style lang="scss">
img {
  display: block;
  border: none;
}
video {
  will-change: auto;
}
#maskVideo {
  > div {
    top: 50%;
    transform: translateY(-50%);
  }
  #fullBtn {
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/goodsDetail/sceen.png) center center no-repeat !important;
    background-size: 40% !important;
  }
}
</style>
<style lang="scss" scoped>
:deep(.van-sticky--fixed) {
  @include max-width;
}

.pre-sale-tip-container{
  position: fixed;
  bottom: 1.2rem;
  left: .32rem;
  z-index: 52;
}
.pre-sale-tip{
  height: .64rem;
  background: rgba(212,228,255,0.85);
  border: .02rem solid #bfd7ff;
  border-radius: .34rem;
  font-size: .24rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #2878ff;
  line-height: .28rem;
  display: flex;
  align-items: center;
  padding: 0 .2rem;
  .tip-icon{
    width: .28rem;
    height: .28rem;
    margin-right: .04rem;
  }
  .tip-close-btn{
    width: .28rem;
    height: .28rem;
    border-radius: .28rem;
    background-color: #88ABF3;
    position: absolute;
    top: -.04rem;
    right: -.04rem;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 0.16rem;
      height: 0.16rem;
      color: #FFFFFF;
    }
  }
}
.detail-page {
  position: relative;
  height: 100%;
  .header {
    height: 0.92rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    // z-index: 1;
    @include max-width;
    transform: translateZ(0);
    z-index: 60; //调高顶部底部zindex以防弹窗覆盖
  }

  .header > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-left: 0.28rem;
    padding-right: 0.28rem;
  }

  .header .right {
    visibility: hidden;
    img {
      -webkit-touch-callout: none;
      pointer-events: none;
    }
  }
  .header .right.show {
    visibility: visible;
  }
  .header .scroll-0 .left {
    width: 0.64rem;
    height: 0.64rem;
    -webkit-touch-callout: none;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: .34rem;
      height: .34rem;
      color: #FFFFFF;
    }
  }

  .header .scroll {
    background-color: #fff;
    border-bottom: 1px solid #eee;
  }

  .header .scroll .left,
  .header .scroll .right {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
    display: flex;
    align-items: center;
  }

  .header .scroll .left {
    width: 0.34rem;
    height: 0.34rem;
  }

  .header .scroll .right img {
    width: 0.34rem;
    height: 0.34rem;
  }
}

.goods-detail-container {
  height: 100%;
}

.inner-view {
  height: 100%;
  width: 7.5rem;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 50%;
  // transform: translateX(-50%);
  margin-left: -50%;
  right: 0;
  padding-bottom: 1.3rem;
  overflow-x: hidden;
  z-index: 20;
  overflow-y: auto;
}

.goods-container {
  width: 7.5rem;
}

.inner-view.sticky {
  top: 0.92rem;
  height: calc(100% - 0.92rem);
}

.header {
  height: 0.92rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  // z-index: 1;
  transform: translateZ(0);
  z-index: 60; //调高顶部底部zindex以防弹窗覆盖
}

.header > div {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 0.28rem;
  padding-right: 0.28rem;
}

.header .right {
  visibility: hidden;
  img {
    -webkit-touch-callout: none;
    pointer-events: none;
  }
}
.header .right.show {
  visibility: visible;
}
.header .scroll-0 img {
  width: 0.64rem;
  height: 0.64rem;
  -webkit-touch-callout: none;
  pointer-events: none;
}

.header .scroll {
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.header .scroll .left,
.header .scroll .right {
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  display: flex;
  align-items: center;
}

.header .scroll .left img {
  width: 0.2rem;
  height: 0.34rem;
}

.header .scroll .right svg {
  width: 0.34rem;
  height: 0.34rem;
}

.detail-livetag {
  position: fixed;
  top: 1.6rem;
  right: 0.26rem;
  z-index: 50;
}

.tab {
  display: flex;
  align-items: center;
  flex: 1;
  padding: 0 1rem;
}

.tab .tab-item {
  flex: 1;
  height: 0.92rem;
  font-size: 0.32rem;
  color: #333;
  display: flex;
  justify-content: center;
}

.tab .tab-item span {
  height: 0.92rem;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
}

.tab .tab-item.active span {
  border-bottom: 0.08rem solid $themeSynMain;
  font-weight: bold;
}

.bottom-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  transform: translateZ(0);
  @include max-width;
  will-change: auto;
  z-index: 50; //调高顶部底部zindex以防弹窗覆盖
}

.bottom-wrap ul {
  height: 64px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-top: 0.02rem solid #eee;
  // border-bottom: 1px solid #eee;
}

.bottom-wrap ul li {
  height: 64px;
  // border-top: 1px solid #eee;
  box-sizing: border-box;
}

.bottom-wrap ul li:nth-child(1),
.bottom-wrap ul li:nth-child(2),
.bottom-wrap ul li:nth-child(3) {
  width: 0.95rem;
  // border-right: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom-wrap ul li:nth-child(3) {
  border-right: none;
}
.bottom-wrap ul li:nth-child(1) {
  .box {
    display: flex;
    justify-content: center;
  }
}
.bottom-wrap ul li:nth-child(2) .img-box,
.bottom-wrap ul li:nth-child(3) .img-box {
  display: flex;
  justify-content: center;
  width: 0.4rem;
  margin: 0 auto;
}
.img-box svg {
  width:0.4rem;
  height:0.4rem
}

.bottom-wrap ul li:nth-child(3) .img-box .box {
  position: relative;
}

.bottom-wrap ul li:nth-child(3) .img-box .box .badge {
  position: absolute;
  left: 0.29rem;
  top: -0.08rem;
  height: 0.24rem;
  background: #ff2e2e;
  border-radius: 0.12rem;
  font-size: 0.2rem;
  color: rgba(255, 255, 255, 1);
  line-height: 0.24rem;
  padding-left: 0.06rem;
  padding-right: 0.06rem;
}

.bottom-wrap ul li:nth-child(1) .text,
.bottom-wrap ul li:nth-child(2) .text,
.bottom-wrap ul li:nth-child(3) .text {
  font-size: 0.2rem;
  color: #333;
  line-height: 28rpx;
  margin-top: 0.18rem;
  text-align: center;
  font-weight: 500;
  font-family: PingFangSC;
  white-space: nowrap;
}
// .bottom-wrap ul li:nth-child(1) {
//   padding-left: .24rem;
//   padding-right: .3rem;
// }
// .bottom-wrap ul li:nth-child(2) {
//   padding-left: .24rem;
//   padding-right: .3rem;
// }
// .bottom-wrap ul li:nth-child(3) {
//   padding-left: .24rem;
//   padding-right: .14rem;
// }
.bottom-wrap ul li:nth-child(4) {
  flex: 1;
  border-top: none;
}

.no-store.bottom-wrap {
  ul li:nth-child(2) {
    margin-left: 0.36rem;
    margin-right: 0.2rem;
  }
  ul li:nth-child(3) {
    margin-left: 0.2rem;
    margin-right: 0.36rem;
  }
}
.bottom-wrap ul li:nth-child(4) .btn-box {
  display: flex;
  height: 100%;
  border-top: 0.02rem solid #eee;
  width: 4.64rem;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: PingFangSC;
  height: 44px;
  background-color: #ffb21f;
  color: #fff;
  margin: auto 0.08rem;
  border-radius: 2rem;
  font-weight: 500;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.bdl {
  border-left: 1px solid #eee;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.bdt {
  border-top: 1px solid #eee;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.bg {
  background-color: #6018ff;
  color: #fff;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn .btn-inner {
  // font-size: 0.24rem;
  font-weight: 500 !important;
  // line-height: 0.32rem;
  // color: $themeSynRed;
  color: #fff;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.bg .btn-inner {
  color: #fff;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.add-cart {
  color: $themeSynMain;
  background-color: #fff;
  border: 1px solid $themeSynMain;
  font-size: .28rem;
  // border-left: 1px solid #eee;
  // border-top: 1px solid #eee;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.buy {
  flex-direction: column;
  color: #fff;
  margin-right: 0.26rem;
  font-size: .28rem;
  p {
    font-size: 12px;
    font-family: PingFangSC;
    font-weight: 500;
  }
  h6 {
    font-size: 0.24rem;
  }
  @include synShadow;
  @include themeSynMainLinearButton;
  background: $themeSynMain;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.orange {
  background: #ff5252;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.arrival-notice {
  background: #ff9e23;
  color: #fff;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.reservation {
  background: #00c1c6;
  color: #fff;
}

.bottom-wrap ul li:nth-child(4) .btn-box .btn.book {
  background: #01cd52;
  color: #fff;
}

.btn-group-flex{
  padding: 0 .1rem;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  >div{
    flex: 1;
    display: flex;
    height: .88rem;
    border-radius: 2rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: $themeSynMain;
    @include synShadow;
    @include themeSynMainLinearButton;
    color: #fff;
    box-sizing: border-box;
    font-size: 0.24rem;
    &.orange{
      background: #ff5252;
      p {
        font-size: 12px;
        font-family: PingFangSC;
        font-weight: 500;
      }
      h6 {
        font-size: 0.24rem;
      }
    }

  }
}

.btn-group-double{
  >div{
    &:first-child{
      background: transparent;
      color: $themeSynMain;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border: 1px solid $themeSynMain;
    }
    &:last-child{
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}

.product-name {
  box-sizing: border-box;
  width: 100%;
  padding: 0.2rem 0.24rem;
  overflow: hidden;
  color: #323233;
  font-size: 0.28rem;
  line-height: 0.48rem;
}

/* 判断iphoneX 将 bottom-wrap 的 padding-bottom 填充到最底部 */
@supports (bottom: env(safe-area-inset-bottom)) {
  .goods-detail-container,
  .bottom-wrap {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .none-sale-container {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .pre-sale-tip-container{
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.share-icon.right {
  width: 0.64rem;
  height: 0.64rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  svg {
    width: 57%;
    height: auto;
    margin: 0.12rem auto;
    color: #fff;
  }
}
.header .scroll .comment-header-title {
  font-size: 0.32rem;
  color: #333;
}
.cancelScroll {
  overflow: hidden;
}
.header .scroll .left,
.header .scroll .right {
  img {
    -webkit-touch-callout: none;
    pointer-events: none;
  }
}
.comment-container {
  padding: 0 12px;
}
#good-component-container :deep(.van-popup) {
  z-index: 2560 !important;
}
#good-component-container :deep(.van-popup--bottom) {
  border-radius: 12px 12px 0 0;
}
.goods-detail-container {
  .product-name {
    font-size: 0.24rem;
    color: #333333;
    padding-top: 0.42rem;
    padding-left: 0.24rem;
    display: flex;
    .title {
      font-weight: bold;
    }
    p {
      width: 3.6rem;
      word-break: break-all;
      margin-left: 0.12rem;
    }
  }
  .van-cell {
    padding-left: 0.24rem;
  }
  .btn-container {
    padding: 0 0.24rem;
    margin-top: 0.4rem;
    .confirm-btn {
      height: 0.76rem;
      background: #2878ff;
      border-radius: 0.38rem;
      font-size: 0.28rem;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.24rem;
    }
  }
  :deep(.van-dialog .van-dialog__header) {
    padding-top: 0;
    font-size: 0.32rem;
    font-weight: bold;
    color: #333333;
    position: relative;
  }
  .dialog-close {
    background: url('~@/assets/imgs/common/close-btn-gray.png') center center no-repeat;
    background-size: cover;
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0.32rem;
    right: 0.32rem;
  }
}

.mask-video {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 1);
  display: none;
  font-size: 0;
  &.active {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.mask-close {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 1rem;
  padding: 0.2rem;
  color: #fff;
  text-align: center;
  font-size: 0.32rem;
  z-index: 300;
  .close {
    position: absolute;
    top: 0.2rem;
    left: 0.2rem;
    width: 0.3rem;
    height: 0.3rem;
    color: #fff;
  }
}
// <div class="none-sale-container">
//             <div class="none-sale-left"><div class="tips-icon"></div><span class="tip-text">此商品不支持在当前地区销售</span></div>
//             <div class="none-sale-right"><span class="location-text">切换地址</span><div class="location-right-arrow"></div></div>
//           </div>
.none-sale-container {
  background-color: #f5a623;
  width: 100%;
  @include max-width;
  height: 0.88rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 64px;
  transform: translateZ(0);
  will-change: auto;
  z-index: 53;
  font-size: 0.28rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #ffffff;
  .none-sale-left {
    margin-left: 0.24rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .tips-icon {
      width: 0.28rem;
      height: 0.28rem;
      margin-right: 0.06rem;
    }
  }
  .none-sale-right {
    margin-right: 0.24rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .location-right-arrow {
      width: 0.24rem;
      height: 0.24rem;
      margin-left: 0.06rem;
      color: #FFFFFF;
    }
  }
}
.bottom-wrap ul li:nth-child(4).disabled .btn {
  position: relative;
  opacity: 0.3;
}
.bottom-wrap ul li:nth-child(4).disabled .group-origin-btn {
  opacity: 0.3;
}
.btn-disabled {
  opacity: 0.3;
}
.group-origin-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.28rem;
  height: 0.74rem;
  background-color: #3b7bf6;
  color: #fff;
  margin: auto 0.08rem;
  border-radius: 2rem;
  font-weight: 500;
  padding: 0 0.48rem;
  .origin-price {
    font-size: 0.24rem;
    color: white;
    font-weight: bold;
    display: inline-block;
    transform: scale(0.83);
  }
  .text {
    font-weight: bold;
    color: white;
    font-size: 0.28rem;
    white-space: nowrap;
  }
}
.share-pic-dialog{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background: rgba(0,0,0,.4);
  z-index: 900;
  > img{
    max-width: 100px;
  }
}

.detail-fixedbtn-dj{
  position: fixed;
  right: 0;
  bottom: 1.2rem;
  width: 2rem;
  height: 2rem;
  background: url(https://statics02.ehaier.com/h5/ehaier/guidian_yydd.png) no-repeat;
  background-size: cover;
  z-index: 99;
}

@supports (bottom: env(safe-area-inset-bottom)){
  .detail-fixedbtn-dj{
    bottom: 2rem;
  }
}


.btn-text{
  font-size: .28rem !important;
}
</style>
